
import { useState, useEffect, useMemo } from "react";
import SideNavLayout from "../customsidenav/sidenavlayout";
import ToastMessage from "../utils/mui/righttoptoast";
import BrainyCareLogo from "../../src/assets/auth/BrainyCare-Logo.jpg";
// import './patient.css';
import { v4 as uuidv4 } from "uuid";
import { Backdrop, CircularProgress } from "@mui/material";
import api from '../api/api'; // Adjust the import path as necessary
import dayjs from "dayjs";
import axios from "axios";
import MuiDatePickerField from "../utils/dateutils/muidatepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import ConfirmAgreementModal from "../onboarding/modals/conformaggrement";
import DisclaimerModal from "../onboarding/modals/declarationmodal";
import LandingPage from "../onboarding/screens/landingPage";
import SaveProgressModal from "../onboarding/modals/saveProgressModal";
import HealthQuestionnaires from "../onboarding/screens/healthQuestionnaires";

const PatientOnboarding = () => {
  const [isVerified, setIsVerified] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);//1
    const [alertmessage, setAlertMessage] = useState('');
  const [severity, setSeverity] = useState('success');
  const[isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
    const handlealert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  const [showDisclaimer, setShowDisclaimer] = useState(false);
const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [errors, setErrors] = useState({});
  const queryParams = useMemo(() => new URLSearchParams(window.location.search), []);
  // const allowToken = queryParams.get('allowtoken');
    const allowToken = true
  const [stepsfilled,setStepsfilled]=useState([])
  const [stepresponse,setStepResponse]=useState({})
  const practiseid = window.getPracticeId();
  const [photouploaded,setPhotouploaded]=useState([]);
  const [isCompleted, setIsCompleted] = useState(false); 
  const [paymentMethod, setPaymentMethod] = useState(); 
  const [loading, setLoading] = useState(false); 
  const [rowId, setRowId] = useState(0);
  const [healthCompleted, setHealthCompleted] = useState({}); 
  

const [otpVerified, setOtpVerified] = useState(false); // tracks if OTP is verified

    // ─── Step 1: define the variables ───
  const [email, setEmail] = useState("");       // email input
  const [phone, setPhone] = useState("");       // phone input
  const [isOtpOpen, setIsOtpOpen] = useState(false); // modal visibility
  const [otp, setOtp] = useState();     // generated OTP (for demo)
 // ─── Step 2: define handlers ───
// OTP verified successfully
const handleVerify = () => {
  setOtpVerified(true);  // ✅ now defined
  setIsOtpOpen(false);
  setCurrentStep(2);    // move to step 2
  save();               // optionally save progress
};

const handleSkip = () => {
  setIsOtpOpen(false);
  setCurrentStep(2);    // move to step 2 even if skipped
};

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

const handleSendEmailotp = async () => {
  const currentEmail = email || formData.email;
  if (!currentEmail) {
    setAlertMessage("Please enter your email address.");
    setSeverity("error");
    setOpen(true);
    return;
  }

  if (!validateEmail(currentEmail)) {
    setAlertMessage("Invalid email address. Please enter a valid email.");
    setSeverity("error");
    setOpen(true);
    return;
  }

  setLoading(true);

  try {
    // Generate 6-digit OTP
    const otp = Math.floor(100000 + Math.random() * 900000); // 100000-999999

    // Email message with HTML styling
    const message = `
      <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #ddd; border-radius: 8px; background-color: #f9f9f9;">
        <h2 style="color: #555;">Your OTP Code</h2>
        <p style="font-size: 16px; line-height: 1.6;">
          Your Verification Code is:
        </p>
        <p style="font-size: 24px; font-weight: bold; color: #1d4ed8; margin: 20px 0;">
          ${otp}
        </p>
        <p style="font-size: 14px; line-height: 1.6;">
          If you did not request this OTP, you can safely ignore this email.
        </p>
        <p style="font-size: 14px; line-height: 1.6; margin-top: 20px;">
          Thanks,<br />
          The Team
        </p>
      </div>
    `;

    // Prepare form data to send to your email API
    const formData = new FormData();
    formData.append("subject", "Your OTP Verification Code");
    formData.append("to", currentEmail);
    formData.append("message", message);

    const resp = await axios.post("/utility/send-email", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })

    if (resp.status === 200) {
      setAlertMessage("OTP sent to your email successfully.");
      setSeverity("success");
      setOpen(true);
      setOtp(otp);
      // Optionally store OTP in state or backend for verification
      console.log("OTP generated:", otp);

      // Clear email field and stop loading
      setEmail("");
    } else {
      setAlertMessage(resp.data?.message || "Failed to send OTP.");
      setSeverity("error");
      setOpen(true);
    }
  } catch (error) {
    console.error(error);
    setAlertMessage("Something went wrong while sending OTP.");
    setSeverity("error");
    setOpen(true);
  } finally {
    setLoading(false);
  }
};


  const [formData, setFormData] = useState({
    licenseFile: null,
  insuranceCardBackBase64:'',
    insuranceCardFrontBase64:'',
 medicationsImagesBase64:[],
 vaccineRecordsBase64:[],
     licensePreview:'',
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    gender: "",
    genderIdentity: "",
    maritalStatus: "",
    referredBy: "",
    referredByOther: "",
    phoneNumber: "",
    email: "",
    address: "",
    city: "",
    zipCode: "",
    emergencyContact: "",
    emergencyPhone: "",

    primaryInsurance: "",
    relationshipToYou: "",
    subscriberName: "",
    subscriberId: "",
    subscriberDOB: "",
    groupId: "",
    subscriberSSN: "",
    insuranceCardFront: null,
    insuranceCardBack: null,
      insuranceCardBackPreview:"",
 insuranceCardFrontPreview:'',
 secondaryInsurance: [],
  tertiaryInsurance: [],
    workersComp: "no",
    autoAccident: "no",


    healthConcerns: [],
    medications: [{medication:"",dose:'',timesPerDay:''}],
    medicationsImages: [],
    surgicalHistory: [{operation:"",date:"",}],
    allergies: [{agent:"",reaction:"",}],
    medicalHistory: [],
    otherProblemDetails: "",
    seriousConditions: {
      cancerYear: "",
      heartAttackYear: "",
      bloodTransfusionYear: "",
      strokeYear: "",
      seizureYear: "",
    },
    gynecologicHistory: {
      pregnancies: "",
      deliveries: "",
      abortions: "",
      miscarriages: "",
      lastPeriodDate: "",
      ageOfFirstPeriod: "",
      periodFrequency: "",
      periodLength: "",
      periodConcerns: "no",
      periodConcernsExplainText: "",
    },

    familyHistory: {},
    noFamilyHistory: false,


    tobaccoUse: "",
    tobaccoQuestions: {
      lastTimeSmoked: "",
      quitDate: "",
      packsPerDay: "",
      yearsSmoking: "",
      otherTobacco: "",
      interestedInQuitting: "",
    },
    alcoholUse: "",
    alcoholQuestions: {
      alcoholPerWeek: "",
      alcoholConcern: "",
    },
    recreationalDrugs: "",
    drugQuestions: {
      usedNeedles: "",
    },
    sexualActive: "",
    sexualityQuestions: {
      sexPartnerGender: "",
      hasSTD: "",
      stdDetails: "",
      stdDate: "",
      birthControl: "",
      safeSex: "",
    },
    ethnicBackground: "",
    numberChildren: "",
    whoLiveWithYou: "",
    occupation: "",
    education: "",
    botheredByProblems: "",
    littlePleasure: "",


    careTeam: [{specialty:'',doctorName:'',phone:''}],
    homeHealthCompany: "",

    reviewOfSystems: [],
    rosOther: "",

    immunizations: {},
    fluTolerance: "",
    vaccineRecords: [],
    privacyConsent: false,
    aiScribeConsent: false,
    electronicConsent: false,
    accuracyConsent: false,
    treatmentConsent: false,
  });
// const validateFields = () => {
//   setIsCompleted(false);
//   let requiredFields = [];
//   let missingFields = []; // For complex validations

//   // Steps 2–8: just save and move to next step
//   if (currentStep >= 2 && currentStep < 9) {
//     save();
//     setCurrentStep((prev) => prev + 1);
//     return;
//   }

//   switch (currentStep) {
//     case 1:
//       // Required fields for Step 1
//       requiredFields = [
//         "firstName",
//         "lastName",
//         "dateOfBirth",
//         "gender",
//         "maritalStatus",
//         "phoneNumber",
//         "email",
//         "address",
//         "city",
//         "zipCode",
//         "emergencyContact",        
//         "emergencyPhone",        
//       ];
//       break;

//     case 9:
//       // Consent fields for Step 9
//       const consentFields = [
//         "privacyConsent",
//         "aiScribeConsent",
//         "electronicConsent",
//         "accuracyConsent",
//         "treatmentConsent",
//       ];

//       const missingConsents = consentFields.filter((field) => !formData[field]);
//       if (missingConsents.length > 0) {
//         missingFields.push("Please confirm your consent");
//       }
//       break;

//     default:
//       requiredFields = [];
//   }

//   // Handle complex missing fields (like consent)
//   if (missingFields.length > 0) {
//     const firstMissing = missingFields[0];
//     setErrors({ [firstMissing]: true });
//     setAlertMessage(firstMissing);
//     setSeverity("error");
//     setOpen(true);
//     return;
//   }

//   // Validate required fields for Step 1
//   if (requiredFields.length > 0) {
//     const firstMissing = requiredFields.find(
//       (field) => !formData[field] || formData[field].toString().trim() === ""
//     );

//     if (firstMissing) {
//       setErrors({ [firstMissing]: true });
//       setAlertMessage(`Please fill out the required field: ${firstMissing}`);
//       setSeverity("error");
//       setOpen(true);
//       return;
//     }
//   }

//   // ✅ Step 1 completed successfully → open OTP modal before Step 2
//   if (currentStep === 1) {
//     // handleSendEmailotp(); // Send OTP to email *************
//     setIsOtpOpen(true); // Show OTP modal
//     return;            // Wait for OTP verification before moving to Step 2
//   }

//   if (currentStep === 9) {
//     save();                  // save last step
//     setIsCompleted(true);    // show final component
//     return;
//   }

//   // For all other steps (like Step 9), just save
//   save();
// };

const validateFields = () => {
  setIsCompleted(false);
  let requiredFields = [];
  let missingFields = []; // For complex validations

  // Steps 2–8: just save and move to next step
  if (currentStep >= 2 && currentStep < 9) {
    save();
    // setCurrentStep((prev) => prev + 1);
    return;
  }

  switch (currentStep) {
    case 1:
      // Required fields for Step 1
      requiredFields = [
        "firstName",
        "lastName",
        "dateOfBirth",
        "gender",
        "maritalStatus",
        "phoneNumber",
        "email",
        "address",
        "city",
        "zipCode",
        "emergencyContact",
        "emergencyPhone",
      ];
      break;

    case 9:
      // Consent fields for Step 9
      const consentFields = [
        "privacyConsent",
        "aiScribeConsent",
        "electronicConsent",
        "accuracyConsent",
        "treatmentConsent",
      ];

      const missingConsents = consentFields.filter((field) => !formData[field]);
      if (missingConsents.length > 0) {
        missingFields.push("Please confirm your consent!");
      }
      break;

    default:
      requiredFields = [];
  }

  // Handle complex missing fields (like consent)
  if (missingFields.length > 0) {
    const firstMissing = missingFields[0];
    setErrors({ [firstMissing]: true });
    setAlertMessage(firstMissing);
    setSeverity("error");
    setOpen(true);
    return;
  }

  // Validate required fields for Step 1
  if (requiredFields.length > 0) {
    const firstMissing = requiredFields.find(
      (field) => !formData[field] || formData[field].toString().trim() === ""
    );

    if (firstMissing) {
      setErrors({ [firstMissing]: true });
      setAlertMessage(`Please fill out the required field: ${firstMissing}`);
      setSeverity("error");
      setOpen(true);
      return;
    }

    // ✅ Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email && !emailRegex.test(formData.email)) {
      setErrors({ email: true });
      setAlertMessage("Please enter a valid email address");
      setSeverity("error");
      setOpen(true);
      return;
    }

    // ✅ Phone validation (basic international format)
    const phoneRegex = /^\+?[0-9]{7,15}$/;
    if (formData.phoneNumber && !phoneRegex.test(formData.phoneNumber)) {
      setErrors({ phoneNumber: true });
      setAlertMessage("Please enter a valid phone number");
      setSeverity("error");
      setOpen(true);
      return;
    }
    if (formData.emergencyPhone && !phoneRegex.test(formData.emergencyPhone)) {
      setErrors({ emergencyPhone: true });
      setAlertMessage("Please enter a valid emergency phone number");
      setSeverity("error");
      setOpen(true);
      return;
    }
  }

  // ✅ Step 1 completed successfully → open OTP modal before Step 2
  if (currentStep === 1) {
    handleSendEmailotp(); // Send OTP to email *************
    setIsOtpOpen(true); // Show OTP modal
    return;            // Wait for OTP verification before moving to Step 2
  }

  if (currentStep === 9) {
    save();                  // save last step
    setIsCompleted(true);    // show final component
    return;
  }

  // For all other steps (like Step 2–8), just save
  save();
};

useEffect(() => {
  // setShowDisclaimer(true);
}, []);




const safeParseForm = (raw) => {
  if (!raw) return null;
  if (typeof raw === "object") return raw;
  try {
    return JSON.parse(raw);
  } catch (e) {
    console.warn("Failed to parse onboarding form payload", e);
    return null;
  }
};

// Defensive coercion helpers so we never propagate broken shapes from a
// previous prefill (LandingPage runs its own prefill first and sometimes
// leaves array fields as "" / objects).
const asArray = (v, fallback = []) => (Array.isArray(v) ? v : fallback);
const asObject = (v, fallback = {}) =>
  v && typeof v === "object" && !Array.isArray(v) ? v : fallback;
const asString = (v, fallback = "") =>
  v === null || v === undefined ? fallback : v;

const prefillOnboarding = async (emailToFetch) => {
  if (!emailToFetch) return;
  try {
    setIsLoading(true);
    const response = await api.get(
      `/v1/${practiseid}/onboarding/get?email=${encodeURIComponent(emailToFetch)}`,
    );
    if (response?.status !== 200) return;
    const record = Array.isArray(response.data)
      ? response.data[0]
      : response.data;
    if (!record) return;

    const f1 = safeParseForm(record.form_1) || {};
    const f2 = safeParseForm(record.form_2) || {};
    const f3 = safeParseForm(record.form_3) || {};
    const f4 = safeParseForm(record.form_4) || {};
    const f5 = safeParseForm(record.form_5) || {};
    const f6 = safeParseForm(record.form_6) || {};
    const f7 = safeParseForm(record.form_7) || {};
    const f8 = safeParseForm(record.form_8) || {};
    const f9 = safeParseForm(record.form_9) || {};

    // Build a single-card insurance array from the flat secondary*/tertiary*
    // fields the backend stores. Used because LandingPage's prefill assumed
    // a nested array shape and left these blank.
    const buildInsCard = (prefix) => {
      const carrier = f2[`${prefix}insurance`];
      const subscriberName = f2[`${prefix}subscribername`];
      if (!carrier && !subscriberName) return [];
      return [
        {
          id: uuidv4(),
          primaryInsurance: asString(carrier),
          relationshipToYou: asString(f2[`${prefix}relationship`]),
          subscriberName: asString(subscriberName),
          subscriberId: asString(f2[`${prefix}subscriberid`]),
          subscriberDOB:
            f2[`${prefix}dob`] && f2[`${prefix}dob`] !== "Invalid date"
              ? f2[`${prefix}dob`]
              : "",
          groupId: asString(f2[`${prefix}groupid`]),
          subscriberSSN: asString(f2[`${prefix}ssn`]),
          insuranceCardFront: null,
          insuranceCardFrontPreview: null,
          insuranceCardBack: null,
          insuranceCardBackPreview: null,
        },
      ];
    };

    // Flatten the API's reviewOfSystems shape ({ category: [symptoms] }) back
    // to a flat array of symptom keys, which is what the step-7 UI expects
    // (it calls formData.reviewOfSystems.includes(...)).
    const flattenROS = (v) => {
      if (Array.isArray(v)) return v;
      if (v && typeof v === "object") return Object.values(v).flat();
      return [];
    };

    setFormData((prev) => ({
      ...prev,

      // ───────── Step 1: personal info ─────────
      firstName: asString(f1.firstname || record.firstname, prev.firstName),
      lastName: asString(f1.lastname || record.lastname, prev.lastName),
      phoneNumber: asString(f1.phone || record.phone, prev.phoneNumber),
      dateOfBirth: asString(f1.dob || record.dob, prev.dateOfBirth),
      gender: asString(f1.gender, prev.gender),
      genderIdentity: asString(f1.genderIdentity, prev.genderIdentity),
      maritalStatus: asString(f1.maritalstatus, prev.maritalStatus),
      referredBy: asString(f1.referrredby, prev.referredBy),
      referredByOther: asString(f1.referrredby_other, prev.referredByOther),
      email: asString(f1.email || record.email, prev.email),
      address: asString(f1.address, prev.address),
      city: asString(f1.city, prev.city),
      zipCode: asString(f1.zipcode, prev.zipCode),
      emergencyContact: asString(f1.emergencycontact, prev.emergencyContact),
      emergencyPhone: asString(f1.emergencyphone, prev.emergencyPhone),

      // ───────── Step 2: insurance ─────────
      paymentMethod: asString(f2.paymentMethod, prev.paymentMethod || ""),
      primaryInsurance: asString(f2.primaryinsurance, prev.primaryInsurance),
      relationshipToYou: asString(
        f2.primaryrelationship,
        prev.relationshipToYou,
      ),
      subscriberName: asString(f2.primarysubscribername, prev.subscriberName),
      subscriberId: asString(f2.subscriberid, prev.subscriberId),
      subscriberDOB:
        f2.primarydob && f2.primarydob !== "Invalid date"
          ? f2.primarydob
          : prev.subscriberDOB,
      groupId: asString(f2.groupid, prev.groupId),
      subscriberSSN: asString(f2.primaryssn, prev.subscriberSSN),
      workersComp: asString(f2.workercompensation, prev.workersComp || "no"),
      autoAccident: asString(f2.autoaccident, prev.autoAccident || "no"),
      secondaryInsurance: buildInsCard("secondary"),
      tertiaryInsurance: buildInsCard("tertiary"),

      // ───────── Step 3: medical history ─────────
      // UI calls .includes / .map on these — must be arrays.
      healthConcerns: asArray(f3.healthconcerns, []),
      medications: asArray(f3.medications, [
        { medication: "", dose: "", timesPerDay: "" },
      ]),
      surgicalHistory: asArray(f3.surgicalHistory, [
        { operation: "", date: "" },
      ]),
      allergies: asArray(f3.allergies, [{ agent: "", reaction: "" }]),
      medicalHistory: asArray(f3.medicalHistory, []),
      noFamilyHistory:
        typeof f4.noFamilyHistory === "boolean"
          ? f4.noFamilyHistory
          : typeof f3.noFamilyHistory === "boolean"
            ? f3.noFamilyHistory
            : !!prev.noFamilyHistory,
      otherProblemDetails: asString(
        f3.otherProblemDetails,
        prev.otherProblemDetails,
      ),
      seriousConditions: {
        ...asObject(prev.seriousConditions),
        ...asObject(f3.seriousConditions),
      },

      // ───────── Step 4: family history ─────────
      familyHistory: asObject(f4.familyHistory, {}),

      // ───────── Step 5: social history ─────────
      tobaccoUse: asString(f5.tobaccoUse, prev.tobaccoUse),
      tobaccoQuestions: {
        ...asObject(prev.tobaccoQuestions),
        ...asObject(f5.tobaccoQuestions),
      },
      alcoholUse: asString(f5.alcoholUse, prev.alcoholUse),
      alcoholQuestions: {
        ...asObject(prev.alcoholQuestions),
        ...asObject(f5.alcoholQuestions),
      },
      recreationalDrugs: asString(
        f5.recreationalDrugs,
        prev.recreationalDrugs,
      ),
      drugQuestions: {
        ...asObject(prev.drugQuestions),
        ...asObject(f5.drugQuestions),
      },
      sexualActive: asString(f5.sexualActive, prev.sexualActive),
      sexualityQuestions: {
        ...asObject(prev.sexualityQuestions),
        ...asObject(f5.sexualityQuestions),
      },
      ethnicBackground: asString(f5.ethnicBackground, prev.ethnicBackground),
      numberChildren: asString(f5.numberChildren, prev.numberChildren),
      whoLiveWithYou: asString(f5.whoLiveWithYou, prev.whoLiveWithYou),
      occupation: asString(f5.occupation, prev.occupation),
      education: asString(f5.education, prev.education),
      botheredByProblems: asString(
        f5.botheredByProblems,
        prev.botheredByProblems,
      ),
      littlePleasure: asString(f5.littlePleasure, prev.littlePleasure),

      // ───────── Step 6: care team ─────────
      careTeam: asArray(f6.careTeam, [
        { specialty: "", doctorName: "", phone: "" },
      ]),
      homeHealthCompany: asString(f6.homeHealthCompany, prev.homeHealthCompany),

      // ───────── Step 7: review of systems ─────────
      // API returns reviewOfSystems as { category: [symptoms] } but step 7 UI
      // expects a flat array because it calls .includes(symptom).
      reviewOfSystems: flattenROS(f7.reviewOfSystems),
      rosOther: asString(f7.rosOther, prev.rosOther),

      // ───────── Step 8: immunizations ─────────
      immunizations: asObject(f8.immunizations, asObject(prev.immunizations)),
      fluTolerance: asString(f8.fluTolerance, prev.fluTolerance),
      // Image lists — backend doesn't return base64s, keep what UI has.
      vaccineRecords: asArray(prev.vaccineRecords, []),
      medicationsImages: asArray(prev.medicationsImages, []),

      // ───────── Step 9: consents ─────────
      privacyConsent: !!(f9.privacyConsent ?? prev.privacyConsent),
      aiScribeConsent: !!(f9.aiScribeConsent ?? prev.aiScribeConsent),
      electronicConsent: !!(f9.electronicConsent ?? prev.electronicConsent),
      accuracyConsent: !!(f9.accuracyConsent ?? prev.accuracyConsent),
      treatmentConsent: !!(f9.treatmentConsent ?? prev.treatmentConsent),
    }));

    // ── IMPORTANT ──
    // Step 2 gates the visible insurance / selfpay sections on the LOCAL
    // `paymentMethod` useState, NOT on formData.paymentMethod. Without
    // this, every step-2 input is unmounted and the page looks "empty"
    // even though formData was prefilled correctly.
    if (f2.paymentMethod) {
      setPaymentMethod(f2.paymentMethod);
    } else if (
      f2.primaryinsurance ||
      f2.secondaryinsurance ||
      f2.tertiaryinsurance
    ) {
      // Record has insurance data even though paymentMethod wasn't saved —
      // default to "insurance" so the inputs render and the user can edit.
      setPaymentMethod("insurance");
    }

    // Seed row id + mark step 0 as filled so subsequent /create_or_update
    // calls become updates (the existing `save()` branches on stepsfilled).
    if (record.id != null) {
      setRowId(record.id);
      setStepResponse({ id: record.id });
    }
    setStepsfilled((prev) => (prev.includes(0) ? prev : [...prev, 0]));
  } catch (err) {
    console.log("prefillOnboarding error:", err);
  } finally {
    setIsLoading(false);
  }
};

// When the user finishes verification, attempt a prefill using their email.
useEffect(() => {
  if (!isVerified) return;
  const e = formData.email || email;
  if (e) prefillOnboarding(e);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [isVerified]);




const addInsuranceCard = (type) => {
  const newCard = {
    id: uuidv4(),
    primaryInsurance: "",
    relationshipToYou: "",
    subscriberName: "",
    subscriberId: "",
    subscriberDOB: "",
    groupId: "",
    subscriberSSN: "",
    insuranceCardFront: null,
    insuranceCardFrontPreview: null,
    insuranceCardBack: null,
    insuranceCardBackPreview: null,
  };

  setFormData(prev => ({
    ...prev,
    [type]: [newCard], // only one card max for the type
  }));
};

const removeInsuranceCard = (type, id) => {
  setFormData(prev => ({
    ...prev,
    [type]: prev[type].filter(item => item.id !== id),
  }));
};

const handleInsuranceChange = (e, type, id) => {
  const { name, value, files } = e.target;

  if (files) {
    const file = files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result; // Base64 string

      setFormData(prev => {
        const updatedList = prev[type].map(item => {
          if (item.id === id) {
            return {
              ...item,
              [name]: file, // store original file if needed
              [`${name}Preview`]: URL.createObjectURL(file), // for <img>
              [`${name}Base64`]: base64String, // store Base64 string
            };
          }
          return item;
        });
        return { ...prev, [type]: updatedList };
      });
    };

    reader.readAsDataURL(file); // Convert file to Base64
  } else {
    setFormData(prev => {
      const updatedList = prev[type].map(item => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      });
      return { ...prev, [type]: updatedList };
    });
  }
};




  // Update step visibility in the UI
  useEffect(() => {
    if (isCompleted) return;
    if (!isVerified) return; 
    document.querySelectorAll('.step').forEach(step => {
      step.classList.remove('active', 'completed');
      const stepNum = parseInt(step.getAttribute('data-step'));
      if (stepNum === currentStep) {
        step.classList.add('active');
      } else if (stepNum < currentStep) {
        step.classList.add('completed');
      }
    });
    document.querySelectorAll('.step-content').forEach(content => {
      content.classList.remove('active');
      if (content.id === `step${currentStep}`) {
        content.classList.add('active');
      }
    });
    document.getElementById('prevBtn').style.display = currentStep === 1 ? 'none' : 'inline-block';
    document.getElementById('nextBtn').textContent = currentStep === 9 ? 'Submit Registration' : 'Continue →';
  }, [currentStep]);

  // Handle input changes for text, select, and radio inputs
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
     setErrors((prev) => ({ ...prev, [name]: false }));
    if (type === 'checkbox') {
      if (name in formData) {
        setFormData((prev) => ({ ...prev, [name]: checked }));
      } else if (name in formData.seriousConditions) {
        setFormData((prev) => ({
          ...prev,
          seriousConditions: { ...prev.seriousConditions, [name]: value },
        }));
      } else if (name in formData.gynecologicHistory) {
        setFormData((prev) => ({
          ...prev,
          gynecologicHistory: { ...prev.gynecologicHistory, [name]: value },
        }));
      } else if (name in formData.tobaccoQuestions) {
        setFormData((prev) => ({
          ...prev,
          tobaccoQuestions: { ...prev.tobaccoQuestions, [name]: value },
        }));
      } else if (name in formData.alcoholQuestions) {
        setFormData((prev) => ({
          ...prev,
          alcoholQuestions: { ...prev.alcoholQuestions, [name]: value },
        }));
      } else if (name in formData.drugQuestions) {
        setFormData((prev) => ({
          ...prev,
          drugQuestions: { ...prev.drugQuestions, [name]: value },
        }));
      } else if (name in formData.sexualityQuestions) {
        setFormData((prev) => ({
          ...prev,
          sexualityQuestions: { ...prev.sexualityQuestions, [name]: value },
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          medicalHistory: checked
            ? [...prev.medicalHistory, name]
            : prev.medicalHistory.filter((item) => item !== name),
        }));
      }
    } else if (name in formData.gynecologicHistory) {
      setFormData((prev) => ({
        ...prev,
        gynecologicHistory: { ...prev.gynecologicHistory, [name]: value },
      }));
    } else if (name in formData.seriousConditions) {
      setFormData((prev) => ({
        ...prev,
        seriousConditions: { ...prev.seriousConditions, [name]: value },
      }));
    } else if (name in formData.tobaccoQuestions) {
      setFormData((prev) => ({
        ...prev,
        tobaccoQuestions: { ...prev.tobaccoQuestions, [name]: value },
      }));
    } else if (name in formData.alcoholQuestions) {
      setFormData((prev) => ({
        ...prev,
        alcoholQuestions: { ...prev.alcoholQuestions, [name]: value },
      }));
    } else if (name in formData.drugQuestions) {
      setFormData((prev) => ({
        ...prev,
        drugQuestions: { ...prev.drugQuestions, [name]: value },
      }));
    } else if (name in formData.sexualityQuestions) {
      setFormData((prev) => ({
        ...prev,
        sexualityQuestions: { ...prev.sexualityQuestions, [name]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Handle file uploads
 const handleFileChange = (e, field) => {
  const files = Array.from(e.target.files);

  if (field === 'licenseFile' || field === 'insuranceCardFront' || field === 'insuranceCardBack') {
    const file = files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result;
      setFormData(prev => ({
        ...prev,
        [field]: file,
        [`${field}Base64`]: base64String, // store Base64 string
      }));
    };

    if (file) {
      reader.readAsDataURL(file);
    }

  } else if (field === 'medicationsImages' || field === 'vaccineRecords') {
 const readers = files.map(file => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve({ file, base64: reader.result });
      };
      reader.readAsDataURL(file);
    });
  });

  Promise.all(readers).then(results => {
    setFormData(prev => ({
      ...prev,
      [field]: [...prev[field], ...results.map(r => r.file)],
      [`${field}Base64`]: [
        ...(prev[`${field}Base64`] || []),
        { [`${field}Base64`]: results.map(r => r.base64) }
      ],
    }));
  });
}
};


  // Handle health concerns autocomplete
  const handleHealthConcernSelect = (concern) => {
    setFormData((prev) => ({
      ...prev,
      healthConcerns: [...new Set([...prev.healthConcerns, concern])],
    }));
    document.getElementById('healthConcerns').value = '';
    document.getElementById('healthSuggestions').style.display = 'none';
  };

  // Remove health concern
  const removeHealthConcern = (concern) => {
    setFormData((prev) => ({
      ...prev,
      healthConcerns: prev.healthConcerns.filter((c) => c !== concern),
    }));
  };

  // Add table rows
  const addMedicationRow = () => {
    setFormData((prev) => ({
      ...prev,
      medications: [...prev.medications, { medication: "", dose: "", timesPerDay: "" }],
    }));
  };

  const addSurgicalRow = () => {
    setFormData((prev) => ({
      ...prev,
      surgicalHistory: [...prev.surgicalHistory, { operation: "", date: "" }],
    }));
  };

  const addAllergyRow = () => {
    setFormData((prev) => ({
      ...prev,
      allergies: [...prev.allergies, { agent: "", reaction: "" }],
    }));
  };

  const addCareTeamRow = () => {
    setFormData((prev) => ({
      ...prev,
      careTeam: [...prev.careTeam, { specialty: "", doctorName: "", phone: "" }],
    }));
  };

  // Update table row data
  const updateTableRow = (index, field, value, table) => {
    setFormData((prev) => ({
      ...prev,
      [table]: prev[table].map((row, i) =>
        i === index ? { ...row, [field]: value } : row
      ),
    }));
  };

  // Remove table row
  const removeTableRow = (index, table) => {
    setFormData((prev) => ({
      ...prev,
      [table]: prev[table].filter((_, i) => i !== index),
    }));
  };

  // Remove uploaded image
  const removeImage = (index, field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: prev[field].filter((_, i) => i !== index),
    }));
  };

  // Toggle visibility functions
  const toggleGynecologicHistory = () => {
    const gynecologicSection = document.getElementById('gynecologicHistory');
    gynecologicSection.style.display = formData.gender === 'female' ? 'block' : 'none';
  };

  const toggleMedicalHistory = () => {
    const container = document.getElementById('medicalHistoryContainer');
    container.classList.toggle('disabled', formData.noFamilyHistory);
  };
const toggleFamilyHistoryTable = () => {
  setFormData((prev) => ({
    ...prev,
    familyHistory: prev.noFamilyHistory ? prev.familyHistory : {},  // reversed here
  }));

};

  const toggleVaccineDate = (vaccine) => {
    setFormData((prev) => ({
      ...prev,
      immunizations: {
        ...prev.immunizations,
        [vaccine]: {
          received: !prev.immunizations[vaccine]?.received,
          date: prev.immunizations[vaccine]?.date || "",
        },
      },
    }));
    const input = document.getElementById(`${vaccine}Date`);
    input.disabled = !input.disabled;
  };
const selectCommonVaccines = () => {
  const commonVaccines = [
    "hepatitisB",
    "shingles",
    "measles",
    "mumps",
    "rubella",
    "varicella",
    "tetanus",
  ];

  setFormData((prev) => ({
    ...prev,
    immunizations: {
      ...prev.immunizations,
      ...commonVaccines.reduce((acc, vaccine) => ({
        ...acc,
        [vaccine]: { received: true, date: "" },
      }), {}),
    },
  }));
};


  const clearAllVaccines = () => {
    setFormData((prev) => ({
      ...prev,
      immunizations: {},
      vaccineRecords: [],
    }));
    document.querySelectorAll('.vaccine-date').forEach((input) => {
      input.disabled = true;
      input.value = "";
    });
    document.querySelectorAll('input[name^="vaccine"]').forEach((checkbox) => {
      checkbox.checked = false;
    });
  };

  const toggleTobaccoQuestions = (show) => {
    document.getElementById('tobaccoQuestions').style.display = show ? 'block' : 'none';
  };

  const toggleAlcoholQuestions = (show) => {
    document.getElementById('alcoholQuestions').style.display = show ? 'block' : 'none';
  };

  const toggleDrugQuestions = (show) => {
    document.getElementById('drugQuestions').style.display = !show ? 'none' : 'block';
  };

  const toggleSexualityQuestions = (show) => {
    document.getElementById('sexualityQuestions').style.display = show ? 'block' : 'none';
  };

  const toggleSTDExplanation = (show) => {
    document.getElementById('stdExplanation').style.display = show ? 'block' : 'none';
  };

  const togglePeriodConcerns = () => {
    const explainSection = document.getElementById('periodConcernsExplain');
    explainSection.style.display = formData.gynecologicHistory.periodConcerns === 'yes' ? 'block' : 'none';
  };

const getForm = () => {
  if (currentStep === 1) {
    return {
      form_name: "form_1",
      firstname: formData.firstName,
      lastname: formData.lastName,
      phone: formData.phoneNumber,
dob: dayjs(formData.dateOfBirth).format("YYYY-MM-DD"),
 dob1: dayjs(formData.dateOfBirth).format("MM-DD-YYYY"),
      gender: formData.gender,
      genderIdentity: formData.genderIdentity,
      maritalstatus: formData.maritalStatus,
      referrredby: formData.referredBy,
      referrredby_other: formData.referredByOther,
      email: formData.email,
      address: formData.address,
      city: formData.city,
      zipcode: formData.zipCode,
      emergencycontact: formData.emergencyContact,
      emergencyphone: formData.emergencyPhone,
      
    };
  }

  if (currentStep === 2) {
    return {
      form_name: "form_2",
      paymentMethod:formData.paymentMethod,
      primaryinsurance: formData.primaryInsurance,//
      primaryrelationship: formData.relationshipToYou,//
      primarysubscribername: formData.subscriberName,//
      subscriberid: formData.subscriberId,//
      primarydob: formData.subscriberDOB,//
      groupid: formData.groupId,//
      primaryssn: formData.subscriberSSN,
     
    
      tertiaryinsurance: formData.tertiaryInsurance,
      workercompensation: formData.workersComp,
      autoaccident: formData.autoAccident,

 
    secondaryinsurance: formData.secondaryInsurance[0]?.primaryInsurance || "",
  secondarysubscribername: formData.secondaryInsurance[0]?.subscriberName || "",
  secondarydob: formData.secondaryInsurance[0]?.subscriberDOB || "",
  secondaryssn: formData.secondaryInsurance[0]?.subscriberSSN || "",
  secondaryrelationship: formData.secondaryInsurance[0]?.relationshipToYou || "",
  secondarysubscriberid: formData.secondaryInsurance[0]?.subscriberId || "",
  secondarygroupid: formData.secondaryInsurance[0]?.groupId || "",
   tertiaryinsurance:formData.tertiaryInsurance[0]?.primaryInsurance || "",
  tertiarysubscribername:formData. tertiaryInsurance[0]?.subscriberName || "",
  tertiarydob: formData.tertiaryInsurance[0]?.subscriberDOB || "Invalid date",
  tertiaryssn:formData.tertiaryInsurance[0]?.subscriberSSN || "",
  tertiaryrelationship:formData.tertiaryInsurance[0]?.relationshipToYou || "",
  tertiarysubscriberid:formData.tertiaryInsurance[0]?.subscriberId || "",
  tertiarygroupid:formData.tertiaryInsurance[0]?.groupId || "",
    "form_name": "form_2",
    "form_type": "INSURANCE"
    };
  }

  if (currentStep === 3) {
    return {
      form_name: "form_3",
      healthconcerns: formData.healthConcerns,
      medications: formData.medications,
   surgicalHistory:formData.surgicalHistory,
   allergies:formData.allergies,
   noFamilyHistory:formData.noFamilyHistory,
    medicalHistory:formData.medicalHistory,
   otherProblemDetails:formData.otherProblemDetails,
   seriousConditions:formData.seriousConditions
    };
  }

  if (currentStep === 4) {
    return {
      form_name: "form_4",
     noFamilyHistory:formData.noFamilyHistory,
     familyHistory:formData.familyHistory
    };
  }

 if (currentStep === 5) {
  return {
    form_name: "form_5",
    tobaccoUse: formData.tobaccoUse,
    tobaccoQuestions: formData.tobaccoQuestions,
    alcoholUse: formData.alcoholUse,
    alcoholQuestions: formData.alcoholQuestions,
    recreationalDrugs: formData.recreationalDrugs,
    drugQuestions: formData.drugQuestions,
    sexualActive: formData.sexualActive,
    sexualityQuestions: formData.sexualityQuestions,
    ethnicBackground: formData.ethnicBackground,
    numberChildren: formData.numberChildren,
    whoLiveWithYou: formData.whoLiveWithYou,
    occupation: formData.occupation,
    education: formData.education,
    botheredByProblems: formData.botheredByProblems,
    littlePleasure: formData.littlePleasure,
  };
}

if (currentStep === 6) {
  return {
    form_name: "form_6",
    careTeam: formData.careTeam,         // Array of care team members
    homeHealthCompany: formData.homeHealthCompany,  // String
  };
}
if (currentStep === 7) {
  return {
    form_name: "form_7",
    reviewOfSystems: structuredReviewOfSystems,  // Array of selected symptom keys
    rosOther: formData.rosOther || "",          // Free-text description of other symptoms
  };
}


  if (currentStep === 8) {
    return {
  form_name: "form_8",
  immunizations: {
    hepatitisA: { received: formData.immunizations.hepatitisA?.received || false, date: formData.immunizations.hepatitisA?.date || "" },
    hepatitisB: { received: formData.immunizations.hepatitisB?.received || false, date: formData.immunizations.hepatitisB?.date || "" },
    pneumonia: { received: formData.immunizations.pneumonia?.received || false, date: formData.immunizations.pneumonia?.date || "" },
    shingles: { received: formData.immunizations.shingles?.received || false, date: formData.immunizations.shingles?.date || "" },
    measles: { received: formData.immunizations.measles?.received || false, date: formData.immunizations.measles?.date || "" },
    mumps: { received: formData.immunizations.mumps?.received || false, date: formData.immunizations.mumps?.date || "" },
    rubella: { received: formData.immunizations.rubella?.received || false, date: formData.immunizations.rubella?.date || "" },
    varicella: { received: formData.immunizations.varicella?.received || false, date: formData.immunizations.varicella?.date || "" },
    tetanus: { received: formData.immunizations.tetanus?.received || false, date: formData.immunizations.tetanus?.date || "" },
    hpv: { received: formData.immunizations.hpv?.received || false, date: formData.immunizations.hpv?.date || "" },
    meningitis: { received: formData.immunizations.meningitis?.received || false, date: formData.immunizations.meningitis?.date || "" },
    otherVaccine: { received: formData.immunizations.otherVaccine?.received || false, date: formData.immunizations.otherVaccine?.date || "" },
    otherVaccineDetails: formData.immunizations.otherVaccineDetails || "",
    flu: { received: formData.immunizations.flu?.received || false, date: formData.immunizations.flu?.date || "" }
  },
  fluTolerance: formData.fluTolerance || ""
}
  }

  if (currentStep === 9) {
  return {
    form_name: "form_9",
    privacyConsent: formData.privacyConsent || false,
    aiScribeConsent: formData.aiScribeConsent || false,
    electronicConsent: formData.electronicConsent || false,
    accuracyConsent: formData.accuracyConsent || false,
    treatmentConsent: formData.treatmentConsent || false,
  };
}

  return {};
};
function cleanBase64(base64String) {
  // Remove the data URL prefix if present
  if (base64String.startsWith("data:image")) {
    return base64String.split(",")[1];
  }
  return base64String;
}

const uploadmedicationImage = async (type) => {
  try {
    setIsLoading(true);

    // Check if this type was already uploaded
    if (photouploaded.includes(type)) {
      console.log(`${type} images already uploaded. Skipping re-upload.`);
      return;
    }

    const records = [];
    let base64Array = [];

    if (type === 'Medication') {
      base64Array = formData.medicationsImagesBase64 || [];
    } else if (type === 'vacination') {
      base64Array = formData.vaccineRecordsBase64 || [];
    }
    
console.log(base64Array)
   base64Array.forEach((base64String) => {
  const imageArray =
    type === 'Medication'
      ? base64String.medicationsImagesBase64
      : base64String.vaccineRecordsBase64;
console.log(imageArray[0],'img')
  records.push({
    insurance_id: formData.primaryInsurance,
    form_type: type === 'Medication' ? "MEDICATION" : "VACCINATION",
    front_image: cleanBase64(imageArray[0]),
  
  });
});


    if (records.length === 0) {
      console.log("No valid image data to upload. Aborting API call.");
      return;
    }

    const response = await api.post(
      `/v1/${practiseid}/onboarding/upload_images`,
      {
        onboarding_id: stepresponse.id,
        status: "1",
        records,
      }
    );

    console.log("Upload successful", response.data);

    // Push type into photouploaded state to track that it was uploaded
    setPhotouploaded((prev) => [...prev, type]);

  } catch (error) {
    console.log("Upload error:", error);
  } finally {
    setIsLoading(false);
  }
};


const uploadinsurances = async () => {
  try {
    setIsLoading(true);

    // Check if already uploaded
    if (photouploaded.includes('Insurance')) {
      console.log('Insurance images already uploaded. Skipping re-upload.');
      return;
    }

    const records = [];

    // Primary Insurance
    if (formData.primaryInsurance) {
      records.push({
        insurance_id: formData.primaryInsurance,
        form_type: "INSURANCE",
        front_image: cleanBase64(formData.insuranceCardFrontBase64) || "",
        back_image: cleanBase64(formData.insuranceCardBackBase64) || "",
      });
    }

    // Secondary Insurance
    if (formData.secondaryInsurance[0]?.primaryInsurance) {
      records.push({
        insurance_id: formData.secondaryInsurance[0].primaryInsurance,
        form_type: "INSURANCE",
        front_image: cleanBase64(formData.secondaryInsurance[0]?.insuranceCardFrontBase64) || "",
        back_image: cleanBase64(formData.secondaryInsurance[0]?.insuranceCardBackBase64) || "",
      });
    }

    // Tertiary Insurance
    if (formData.tertiaryInsurance[0]?.primaryInsurance) {
      records.push({
        insurance_id: formData.tertiaryInsurance[0].primaryInsurance,
        form_type: "INSURANCE",
        front_image: cleanBase64(formData.tertiaryInsurance[0]?.insuranceCardFrontBase64) || "",
        back_image: cleanBase64(formData.tertiaryInsurance[0]?.insuranceCardBackBase64) || "",
      });
    }

    if (records.length === 0) {
      console.log("No valid insurance data to upload. Aborting API call.");
      return;
    }

    const response = await api.post(
      `/v1/${practiseid}/onboarding/upload_images`,
      {
        onboarding_id: stepresponse.id,
        status: "1",
        records,
      }
    );

  

    // Mark as uploaded
    setPhotouploaded((prev) => [...prev, 'Insurance']);

  } catch (error) {
    console.log("Upload error:", error);
  } finally {
    setIsLoading(false);
  }
};

const systemCategories = {
  Breasts: ['BreastPain'],
  Constitutional: ['Fever', 'UnexplainedWeightLoss', 'Fatigue'],
  Eyes: ['ChangeInVision'],
  Ears_Nose_Throat_Mouth: ['DifficultHearing', 'RingingInEars', 'ProblemsWithTeeth', 'HayFever'],
  Respiratory: ['CoughWheeze', 'DifficultBreathing'],
  Cardiovascular: ['ChestPain', 'LegPain', 'Palpitations'],
  Gastrointestinal: ['AbdominalPain', 'Heartburn', 'BloodyBowel', 'NauseaVomiting', 'Constipation', 'ChangeInBowel'],
  Genitourinary: ['NighttimeUrination', 'DifficultyUrination', 'LeakingUrine', 'BloodInUrine', 'DischargeFromPenis', 'SexualFunctionProblems'],
  Musculoskeletal: ['MusculoskeletalPain'],
  Neurological: ['Headaches', 'Dizziness', 'Numbness', 'MemoryLoss', 'LossOfCoordination'],
  Psychiatric: ['AnxietyStress', 'ProblemsWithSleep', 'Depression'],
  Skin: ['RashMoles', 'Itching'],
  Blood_Lymphatic: ['UnexpectedLumps', 'BruisingBleeding', 'ExcessiveThirst'],
};

// const structuredReviewOfSystems = {};

// for (const [category, symptoms] of Object.entries(systemCategories)) {
//   structuredReviewOfSystems[category] = symptoms.filter(symptomKey => {
//     // Remove 'ros' prefix
//     const plainSymptom = symptomKey.replace(/^ros/, '');
//     return formData.reviewOfSystems.includes(plainSymptom);
//   });
// }
// Make sure formData.reviewOfSystems exists
const reviewOfSystemsObj = formData.reviewOfSystems || {};
// Flatten all categories into a single array
const flattenedROS = Object.values(reviewOfSystemsObj).flat();
// Now you can use flattenedROS safely
const structuredReviewOfSystems = {};

for (const [category, symptoms] of Object.entries(systemCategories)) {
  structuredReviewOfSystems[category] = symptoms.filter(symptomKey => {
    // Remove 'ros' prefix
    const plainSymptom = symptomKey.replace(/^ros/, '');
    return flattenedROS.includes(plainSymptom);
  });
}

console.log(structuredReviewOfSystems);


const save=async()=>{
  try{
setIsLoading(true)
let payload={

}
console.log(currentStep)
if (stepsfilled.includes(0)) {

  if(!stepresponse.id){
    stepresponse.id = rowId;
  }

  if(currentStep==1){
payload.row_id=stepresponse.id
payload.form_1=getForm()
  }

if(currentStep==2){
payload.row_id=stepresponse.id
payload.form_2=getForm()
uploadinsurances()
}else if(currentStep==3){
  payload.row_id=stepresponse.id
  payload.form_3=getForm()
  uploadmedicationImage('Medication')
  
}else if(currentStep==4){
 payload.row_id=stepresponse.id
  payload.form_4=getForm()
}else if(currentStep==5){
   payload.row_id=stepresponse.id
  payload.form_5=getForm()
}else if(currentStep==6){
   payload.row_id=stepresponse.id
  payload.form_6=getForm()
}else if(currentStep==7){
  console.log(formData,'foooooooooo')
   payload.row_id=stepresponse.id
  payload.form_7=getForm()
}else if(currentStep==8){
   payload.row_id=stepresponse.id
  payload.form_8=getForm()
    uploadmedicationImage('vacination')
}else if(currentStep==9){
   payload.row_id=stepresponse.id
  payload.form_9=getForm()
 
}
  console.log(currentStep)
 


} else {
  payload.firstname = formData.firstName;
  payload.lastname = formData.lastName;
  payload.phone = formData.phoneNumber;
  payload.dob = dayjs(formData.dateOfBirth).format("YYYY-MM-DD"); // formatted DOB
  payload.email = formData.email;
  payload.form_1 = getForm();
  payload.profilepic = formData.profilePreview
    ? formData.profilePreview.split(",")[1] // raw base64 only
    : "";
    setStepsfilled(prev => [...prev, 0]);
    
}

// console.log("payloiad data", payload);return;
// return;//**************** For testing only, remove this return in production to enable API call ***************
 const response=await api.post(`/v1/${practiseid}/onboarding/create_or_update_patient`,payload)

if(response.status==200){
  setStepResponse(response.data);
  setRowId(response.data.id);
  console.log('response data:', response.data);
  console.log('rowId set to:', response.data.id);

 if(currentStep===9){
   setAlertMessage(`Patient onBoarded Successfully`);
      setSeverity("success");
      setOpen(true)      
      setStepResponse('')
   
      
  //     setTimeout(() => {
  //   window.location.reload();
  // }, 2000);

 }
       
  if(currentStep!==9 && currentStep!==1){
      nextStep()
  }
}else{
   setAlertMessage(response.message||'')
   
      setSeverity("info");
      setOpen(true)
  setStepResponse({})
}

  }catch(error){
    console.log(error)  
  }finally{
setIsLoading(false)
  }
}
const extractfromocr = async (img) => {
  setIsLoading(true);
  try {
    const formDataToSend = new FormData();
    formDataToSend.append("image", img);

    const response = await api.post(
      `/v1/${practiseid}/onboarding/upload_dl`,
      formDataToSend,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (response) {
      console.log("OCR Response:", response);

      // Parse OCR result safely
      const parsed =
        typeof response=== "string"
          ? JSON.parse(response)
          : response;

      // ✅ Assign only non-empty valid fields
      setFormData((prev) => ({
        ...prev,
        firstName: parsed.First_Name || prev.firstName,
        lastName: parsed.Last_Name || prev.lastName,
        dateOfBirth: parsed.Date_of_Birth || prev.dateOfBirth,
        gender: parsed.Gender==='Male'?'male':'female' || prev.gender,
        phoneNumber: parsed.Phone_Number || prev.phoneNumber,
        address: parsed.Address || prev.address,
        city: parsed.City || prev.city,
        zipCode: parsed.Zip_Code || prev.zipCode,
      }));

      setAlertMessage("Details Extracted Successfully");
      setSeverity("success");
      setOpen(true);
    }
  } catch (error) {
    console.error("OCR Upload Error:", error);
    setAlertMessage("Failed to extract details. Try again.");
    setSeverity("error");
    setOpen(true);
  } finally {
    setIsLoading(false);
  }
};


  // Navigation
  const nextStep = () => {
  
    setCurrentStep((prev) => Math.min(prev + 1, 9));
      window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const previousStep = () => {
    setIsCompleted(false);
    setCurrentStep((prev) => Math.max(prev - 1, 1));
      window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const clearCurrentStep = () => {
    if (currentStep === 1) {
      setFormData((prev) => ({
        ...prev,
        licenseFile: null,
        firstName: "",
        lastName: "",
        dateOfBirth: "",
        gender: "",
        genderIdentity: "",
        maritalStatus: "",
        referredBy: "",
        referredByOther: "",
        phoneNumber: "",
        email: "",
        address: "",
        city: "",
        zipCode: "",
        emergencyContact: "",
        emergencyPhone: "",
      }));
    } else if (currentStep === 2) {
      setFormData((prev) => ({
        ...prev,
        primaryInsurance: "",
        relationshipToYou: "",
        subscriberName: "",
        subscriberId: "",
        subscriberDOB: "",
        groupId: "",
        subscriberSSN: "",
        insuranceCardFront: null,
        insuranceCardBack: null,
        workersComp: "no",
        autoAccident: "no",
      }));
    } else if (currentStep === 3) {
      setFormData((prev) => ({
        ...prev,
        healthConcerns: [],
        medications: [],
        medicationsImages: [],
        surgicalHistory: [],
        allergies: [],
        medicalHistory: [],
        otherProblemDetails: "",
        seriousConditions: {
          cancerYear: "",
          heartAttackYear: "",
          bloodTransfusionYear: "",
          strokeYear: "",
          seizureYear: "",
        },
        gynecologicHistory: {
          pregnancies: "",
          deliveries: "",
          abortions: "",
          miscarriages: "",
          lastPeriodDate: "",
          ageOfFirstPeriod: "",
          periodFrequency: "",
          periodLength: "",
          periodConcerns: "no",
          periodConcernsExplainText: "",
        },
      }));
    } else if (currentStep === 4) {
      setFormData((prev) => ({
        ...prev,
        familyHistory: {},
        noFamilyHistory: false,
      }));
    } else if (currentStep === 5) {
      setFormData((prev) => ({
        ...prev,
        tobaccoUse: "never",
        tobaccoQuestions: {
          lastTimeSmoked: "",
          quitDate: "",
          packsPerDay: "",
          yearsSmoking: "",
          otherTobacco: "",
          interestedInQuitting: "",
        },
        alcoholUse: "never",
        alcoholQuestions: {
          alcoholPerWeek: "",
          alcoholConcern: "",
        },
        recreationalDrugs: "no",
        drugQuestions: {
          usedNeedles: "",
        },
        sexualActive: "no",
        sexualityQuestions: {
          sexPartnerGender: "",
          hasSTD: "",
          stdDetails: "",
          stdDate: "",
          birthControl: "",
          safeSex: "",
        },
        ethnicBackground: "",
        numberChildren: "",
        whoLiveWithYou: "",
        occupation: "",
        education: "",
        botheredByProblems: "",
        littlePleasure: "",
      }));
    } else if (currentStep === 6) {
      setFormData((prev) => ({
        ...prev,
        careTeam: [],
        homeHealthCompany: "",
      }));
    } else if (currentStep === 7) {
      setFormData((prev) => ({
        ...prev,
        reviewOfSystems: [],
        rosOther: "",
      }));
    } else if (currentStep === 8) {
      setFormData((prev) => ({
        ...prev,
        immunizations: {},
        fluTolerance: "",
        vaccineRecords: [],
      }));
    } else if (currentStep === 9) {
      setFormData((prev) => ({
        ...prev,
        privacyConsent: false,
        aiScribeConsent: false,
        electronicConsent: false,
        accuracyConsent: false,
        treatmentConsent: false,
      }));
    }
  };     



  // Autocomplete suggestions (simplified for demo)
  const suggestions = [
    "Hypertension",
    "Diabetes",
    "Asthma",
    "Arthritis",
    "Allergies",
    "Chronic Pain",
    "Anxiety",
    "Depression",
  ];

  const handleAutocomplete = (e) => {
    const value = e.target.value.toLowerCase();
    const suggestionsDiv = document.getElementById('healthSuggestions');
    suggestionsDiv.innerHTML = '';
    if (value) {
      const filtered = suggestions.filter((s) => s.toLowerCase().includes(value));
      filtered.forEach((s) => {
        const div = document.createElement('div');
        div.className = 'suggestion-item';
        div.textContent = s;
        div.onclick = () => handleHealthConcernSelect(s);
        suggestionsDiv.appendChild(div);
      });
      suggestionsDiv.style.display = filtered.length ? 'block' : 'none';
    } else {
      suggestionsDiv.style.display = 'none';
    }
  };

  // Add secondary/tertiary insurance (simplified for demo)
  const addSecondaryInsurance = () => {
    alert("Secondary insurance form would be added here.");
    // Implement logic to add secondary insurance form
  };

  const addTertiaryInsurance = () => {
    alert("Tertiary insurance form would be added here.");
    // Implement logic to add tertiary insurance form
  };
const handleStepClick = (targetStep) => {
  // If user is going backwards → allow without validation
  if (targetStep < currentStep) {
    setCurrentStep(targetStep);
    return;
  }

  let requiredFields = [];
  let missingFields = [];

  switch (currentStep) {
    case 1:
      requiredFields = [
        "firstName",
        "lastName",
        "dateOfBirth",
        "gender",
        "maritalStatus",
        "emergencyPhone",
      ];
      break;

    case 2:
      requiredFields = [
        // your step-2 fields here
      ];
      break;

    // case 3:
    //   // Example: consent validations
    //   const consentFields = ["consent1", "consent2", "consent3"];
    //   const missingConsents = consentFields.filter(
    //     (field) => !formData[field]
    //   );

    //   if (missingConsents.length > 0) {
    //     setAlertMessage("Please confirm your consent");
    //     setSeverity("error");
    //     setOpen(true);
    //     return;
    //   }
    //   break;

    default:
      requiredFields = [];
  }

  if (currentStep === 1 ) {
  validateFields()
  return
  }

  // If all validations pass → allow moving to the clicked step
  setCurrentStep(targetStep);
};

  return (
    <>
    {!isVerified ? (
        <LandingPage onVerified={() => setIsVerified(true)} setCurrentStep={setCurrentStep} setIsCompleted={setIsCompleted} setRowId={setRowId} setHealthCompleted={setHealthCompleted} setStepsfilled={setStepsfilled} setFormData={setFormData} />
      ) : (
    <SideNavLayout>
      <div>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>New Patient Registration</title>
 {!isCompleted && ( 
          <div
  className={`${
    allowToken ? "w-full sm:max-w-[80%]" : "w-full sm:max-w-4xl"
  } mx-auto bg-white sm:rounded-3xl shadow-xl overflow-hidden`}
>
{/* Header  */}
<div className="header bg-[#1b2340] bg-gradient-to-b from-[#1b2340] to-[#111827] text-white sm:p-5 md:p-[4rem] lg:p-[6rem]  text-center font-[Fraunces]">
  <div className="flex items-center justify-center mb-2">
    <div className="flex items-center space-x-4">
      <img
        src={BrainyCareLogo}
        alt="Profile Preview"
        className="w-10"
      />
      <div className="text-[14px] tracking-[0.32em] text-[var(--gold)] uppercase text-left">
        Center for Hypertension <br/>& Internal Medicine
      </div>
    </div>
  </div>
  <h1 className="text-2xl sm:text-3xl font-semibold mb-3 sm:mb-5">New Patient Registration</h1>
<div className="flex flex-wrap   gap-x-2 gap-y-2 md:flex-nowrap justify-center md:justify-between items-start max-w-full mx-auto px-3 md:px-5 gap-y-6">
  {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((step) => (
    <div
      key={step}
      className={`
        flex flex-col items-center flex-none md:flex-1 relative cursor-pointer
        transition-all duration-300 ease-in-out

        ${step === currentStep ? "scale-105" : step < currentStep ? "opacity-90" : ""}

        /* Connector visible only on md+ */
        md:before:content-[''] md:before:absolute md:before:top-3.5 md:before:left-1/2 
        md:before:right-[-50%] md:before:w-full md:before:h-[2px]
        md:before:bg-white/30 md:last:before:hidden
        ${step < currentStep ? "md:before:bg-white/80" : ""}
      `}
    onClick={() => handleStepClick(step)}
    >
      {/* Circle */}
      <div
        className={`
          w-[30px] h-[30px] rounded-full flex items-center justify-center
          font-semibold text-sm mb-1 relative z-[2]
          transition-all duration-300 ease-in-out

          ${step === currentStep
            ? "bg-white text-indigo-600 scale-110 border-2 border-[#c9a35b] shadow-[0_0_0_3px_rgba(255,255,255,0.3)]"
            : step < currentStep
            ? "bg-white/90 text-emerald-500"
            : "bg-white/30 text-white border-2 border-[#ffffff50]"}
        `}
      >
        {step < currentStep ? "✓" : step}
      </div>

      {/* Labels — Hidden on mobile, visible on desktop */}
      <div
        className={`
          hidden md:block text-xs text-center opacity-80 leading-tight
          ${step === currentStep ? "opacity-100 font-semibold text-[#c9a35b]" : ""}
        `}
      >
        {[
          "Personal Info",
          "Insurance",
          "Medical History",
          "Family History",
          "Social History",
          "Care Team",
          "Review of Systems",
          "Immunizations",
          "Review & Submit",
        ][step - 1]}
      </div>
    </div>
  ))}
</div>

{/* Mobile: Show ONLY current step label */}
<div className="md:hidden text-center mt-3 text-sm font-semibold text-white">
  {[
    "Personal Info",
    "Insurance",
    "Medical History",
    "Family History",
    "Social History",
    "Care Team",
    "Review of Systems",
    "Immunizations",
    "Review & Submit",
  ][currentStep - 1]}
</div>

</div>
{/* Header close  */}
          <div className="p-4 sm:p-10"
          
          >
        {currentStep==1 && !isCompleted && <div className={`step-content  ${currentStep === 1 ? 'active' : ''}`} id="step1">
{/* <div
  className="flex flex-col items-center justify-center p-6 border border-gray-300 rounded-lg cursor-pointer hover:border-blue-500 transition"
  onClick={() => document.getElementById('profileInput').click()}
>
  <input
    type="file"
    id="profileInput"
    accept="image/*"
    className="hidden"
    onChange={(e) => {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setFormData((prev) => ({
            ...prev,
            profileFile: file,
            profilePreview: reader.result,
          }));
        };
        reader.readAsDataURL(file);
      }
    }}
  />

  <FontAwesomeIcon
    icon={faUserCircle}
    className="text-gray-500 text-6xl mb-3"
  />


  <span className="text-gray-700 font-medium text-sm">
    Upload Profile Picture
  </span>


  {formData.profilePreview && (
    <div className="mt-4">
      <img
        src={formData.profilePreview}
        alt="Profile Preview"
        className="w-24 h-24 rounded-full object-cover border border-gray-300 shadow-sm"
      />
    </div>
  )}
</div> */}

          
{/* <div
  className="bg-gradient-to-br from-sky-50 to-sky-100 border-2 border-dashed border-sky-400 rounded-xl p-8 text-center mb-10 cursor-pointer hover:from-sky-100 hover:to-sky-50 hover:border-sky-600 transition-transform transform hover:-translate-y-0.5"
  onClick={() => document.getElementById('licenseInput').click()}
>
 <input
  type="file"
  id="licenseInput"
  accept="image/*"
  className="hidden"
  onChange={(e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prev) => ({
          ...prev,
          licenseFile: file,
          licensePreview: reader.result, 
        }));
      };
      reader.readAsDataURL(file);
    }
  }}
/>


  <div className="w-16 h-16 bg-sky-500 rounded-full flex items-center justify-center mx-auto mb-4">
    <svg fill="currentColor" viewBox="0 0 24 24" className="w-8 h-8 text-white">
      <path d="M12,2L2,7V17A2,2 0 0,0 4,19H8V21A2,2 0 0,0 10,23H14A2,2 0 0,0 16,21V19H20A2,2 0 0,0 22,17V7L12,2M13,8H18L13,3.5L8,8H13M12,21A1,1 0 0,1 11,20V11A1,1 0 0,1 12,10A1,1 0 0,1 13,11V20A1,1 0 0,1 12,21M12,19C10.9,19 10,18.1 10,17C10,15.9 10.9,15 12,15C13.1,15 14,15.9 14,17C14,18.1 13.1,19 12,19Z" />
    </svg>
  </div>


  <div className="text-center">
    <h3 className="text-xl font-semibold text-slate-900">Upload Driver's License</h3>
    <p className="text-sm text-slate-500 mt-1">
      Take a photo or upload an image to auto-fill your information
    </p>

    <button
      type="button"
      className="mt-4 px-6 py-2 bg-sky-500 text-white rounded-lg font-semibold hover:bg-sky-600 transition-transform transform hover:-translate-y-0.5"
    >
      Choose File or Take Photo
    </button>
  </div>
{formData.licensePreview && (
    <div className="mt-4 flex justify-center">
      <img
        src={formData.licensePreview}
        alt="License Preview"
        className="w-24 h-auto rounded-lg border border-gray-300 shadow-sm"
      />
    </div>
  )}

  <div id="ocrStatus" className="ocr-status mt-3 text-sm hidden" />
</div> */}
<div
  className="bg-gradient-to-br from-sky-50 to-sky-100 border-2 border-dashed border-sky-400 
             rounded-xl p-6 sm:p-8 text-center mb-10 cursor-pointer 
             hover:from-sky-100 hover:to-sky-50 hover:border-sky-600 
             transition-transform transform hover:-translate-y-0.5
             w-full max-w-full mx-auto"
onClick={() => {
  const input = document.getElementById("licenseInput");
  if (input) input.click();
}}


>
  <input
    type="file"
    id="licenseInput"

accept="image/*;capture=camera"
    className="hidden"
  
    onChange={async (e) => {
      const file = e.target.files[0];
      if (file) {
        e.target.value = "";
        const reader = new FileReader();
        reader.onloadend = () => {
          setFormData((prev) => ({
            ...prev,
            profileFile: file,
            profilePreview: reader.result,
          }));
        };
        reader.readAsDataURL(file);
        await extractfromocr(file);
      }
    }}
  />

  {/* Icon */}
  <div className="w-14 h-14 sm:w-16 sm:h-16 bg-sky-500 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
    <svg fill="currentColor" viewBox="0 0 24 24" className="w-7 h-7 sm:w-8 sm:h-8 text-white">
      <path d="M12,2L2,7V17A2,2 0 0,0 4,19H8V21A2,2 0 0,0 10,23H14A2,2 0 0,0 16,21V19H20A2,2 0 0,0 22,17V7L12,2M13,8H18L13,3.5L8,8H13M12,21A1,1 0 0,1 11,20V11A1,1 0 0,1 12,10A1,1 0 0,1 13,11V20A1,1 0 0,1 12,21M12,19C10.9,19 10,18.1 10,17C10,15.9 10.9,15 12,15C13.1,15 14,15.9 14,17C14,18.1 13.1,19 12,19Z" />
    </svg>
  </div>

  {/* Text */}
  <div className="text-center px-2">
    <h3 className="text-lg sm:text-xl font-semibold text-slate-900">
      Upload Driver's License
    </h3>
    <p className="text-xs sm:text-sm text-slate-500 mt-1">
      Take a photo or upload an image to auto-fill your information
    </p>

    <button
      type="button"
      className="mt-4 px-4 sm:px-6 py-2 bg-sky-500 text-white rounded-lg font-semibold 
                 hover:bg-sky-600 transition-transform transform hover:-translate-y-0.5
                 text-sm sm:text-base"
    >
      Choose File or Take Photo
    </button>
  </div>

  {/* Preview Image */}
  {formData.profilePreview && (
    <div className="mt-4 flex justify-center">
      <img
        src={formData.profilePreview}
        alt="Preview"
        className="w-20 h-20 sm:w-24 sm:h-24 rounded-lg object-cover border border-gray-300 shadow-sm"
      />
    </div>
  )}

  {/* Status message */}
  <div id="ocrStatus" className="ocr-status mt-3 text-sm hidden" />
</div>




  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
    <div className="text-start">
     <label
  htmlFor="firstName"
  className={`block text-sm font-semibold mb-2 ${
    errors.firstName ? "text-red-600" : "text-slate-700"
  }`}
>
  First Name *
</label>

      <input
        type="text"
        id="firstName"
        name="firstName"
        value={formData.firstName}
        onChange={handleInputChange}
     
          className={`mt-1 block w-full text-start rounded-xl border-2 p-3 
    bg-gray-50 focus:bg-white focus:ring-2 transition
    ${errors.firstName 
        ? "border-red-500 focus:border-red-500 focus:ring-red-200" 
        : "border-gray-200 focus:border-indigo-600 focus:ring-indigo-100"
    }
  `}
      />
    </div>

    <div className="text-start">
      <label
  htmlFor="lastName"
  className={`block text-sm font-semibold mb-2 ${
    errors.lastName ? "text-red-600" : "text-slate-700"
  }`}
>
  Last Name *
</label>

      <input
        type="text"
        id="lastName"
        name="lastName"
        value={formData.lastName}
        onChange={handleInputChange}
     className={`mt-1 block w-full text-start rounded-xl border-2 p-3 bg-gray-50 
    focus:bg-white focus:ring-2 transition sm:text-sm
    ${
      errors.lastName
        ? "border-red-500 focus:border-red-500 focus:ring-red-200"
        : "border-gray-200 focus:border-indigo-600 focus:ring-indigo-100"
    }
  `}
     />
    </div>
  </div>

  {/* DOB + Gender */}
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
    <div className="text-start "
       
    >
    <label
  htmlFor="dateOfBirth"
  className={`block text-sm font-semibold mb-2 ${
    errors.dateOfBirth ? "text-red-600" : "text-slate-700"
  }`}
>
  Date of Birth *
</label>

      <style>
{`
  .MuiFormControl-root {
    width: 100% !important;
  }
  .MuiInputBase-root {
    width: 100% !important;
  }
`}
</style>
{errors.dateOfBirth?<div   style={{
    width: "100%",
    border: errors.dateOfBirth ? "2px solid red" : "2px solid #e5e7eb",
    borderRadius: "12px",
 backgroundColor: "#f9fafb",
  
  }}>
  <MuiDatePickerField
    label="" // label handled externally with Tailwind styling
    name="dateOfBirth"
    value={formData.dateOfBirth}
    onChange={handleInputChange}
    disableFuture={true} // same as max={today}
    style={{
    width: "100%",
    border: errors.dateOfBirth ? "2px solid red" : "2px solid #e5e7eb",
    borderRadius: "12px",
    backgroundColor: "#f9fafb",
    padding: "4px 8px"
  }}
  className="w-full"   
  />

</div>:  <MuiDatePickerField
    label="" // label handled externally with Tailwind styling
    name="dateOfBirth"
    value={formData.dateOfBirth}
    onChange={handleInputChange}
    disableFuture={true} // same as max={today}
    style={{
    width: "100%",
    border: errors.dateOfBirth ? "2px solid red" : "2px solid #e5e7eb",
    borderRadius: "12px",
    backgroundColor: "#f9fafb",
    padding: "4px 8px"
  }}
  className="w-full"   
  />}
   
    </div>

  <div className="text-start">
  <label
    className={`block text-sm font-semibold mb-2 ${
      errors.gender ? "text-red-600" : "text-slate-700"
    }`}
  >
    Sex Assigned at Birth *
  </label>
    <p className="text-xs text-gray-500 mt-[-1] mx-0 mb-2.5">
      Used to determine relevant clinical questions.
    </p>
  {/* Border wrapper */}
  <div
    className="flex flex-wrap gap-3"
  >
    <label className="inline-flex items-center gap-2 text-sm">
      <input
        type="radio"
        name="gender"
        value="male"
        checked={formData.gender === "male"}
        onChange={handleInputChange}
        className="accent-indigo-600"
      />
      Male
    </label>

    <label className="inline-flex items-center gap-2 text-sm">
      <input
        type="radio"
        name="gender"
        value="female"
        checked={formData.gender === "female"}
        onChange={handleInputChange}
        className="accent-indigo-600"
      />
      Female
    </label>
    <label className="inline-flex items-center gap-2 text-sm">
      <input
        type="radio"
        name="gender"
        value="intersex"
        checked={formData.gender === "intersex"}
        onChange={handleInputChange}
        className="accent-indigo-600"
      />
      Intersex
    </label>
    <label className="inline-flex items-center gap-2 text-sm">
      <input
        type="radio"
        name="gender"
        value="prefer not to say"
        checked={formData.gender === "prefer not to say"}
        onChange={handleInputChange}
        className="accent-indigo-600"
      />
      Prefer not to say
    </label>            
  </div>
</div>

  </div>



{/* Gender Identity Dropdown */}
<div className="form-grid mb-6">
  <div className="form-group">
    <label htmlFor="genderIdentity" className="text-start block text-sm font-semibold mb-1">
      Gender Identity
    </label>
    <p className="text-start text-xs text-gray-500 mt-[-1] mb-2.5">
      Optional — helps us provide more personalized care.
    </p>
    <select
      id="genderIdentity"
      name="genderIdentity"
      value={formData.genderIdentity || ""}
      onChange={handleInputChange}
      className={`mt-1 block w-full rounded-xl p-3 bg-gray-50 text-sm
        outline-none transition
        border-2 border-gray-200 focus:border-indigo-600 focus:ring-indigo-100
      `}
    >
      <option value="">Select gender identity</option>
      <option value="man">Man</option>
      <option value="woman">Woman</option>
      <option value="nonBinary">Non-binary</option>
      <option value="transgenderMan">Transgender man</option>
      <option value="transgenderWoman">Transgender woman</option>
      <option value="genderqueer">Genderqueer / Gender fluid</option>
      <option value="agender">Agender</option>
      <option value="preferNotToSay">Prefer not to say</option>
      <option value="notListed">Not listed (please specify below)</option>
    </select>
  </div>

  {/* Conditionally show “Please specify” input */}
  {formData.genderIdentity === "notListed" && (
    <div className="form-group mt-4">
      <label htmlFor="genderIdentityOther" className="text-start block text-sm font-semibold mb-1">
        Please specify
      </label>
      <input
        type="text"
        id="genderIdentityOther"
        name="genderIdentityOther"
        placeholder="Describe your gender identity"
        value={formData.genderIdentityOther || ""}
        onChange={handleInputChange}
        className="mt-1 block w-full rounded-xl p-3 bg-gray-50 text-sm
          outline-none transition border-2 border-gray-200
          focus:border-indigo-600 focus:ring-indigo-100
        "
      />
    </div>
  )}
</div>


  {/* Marital Status + Referred By */}
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
  <div className="text-start">
  <label
    htmlFor="maritalStatus"
    className={`block text-sm font-semibold mb-2 ${
      errors.maritalStatus ? "text-red-600" : "text-slate-700"
    }`}
  >
    Marital Status *
  </label>

  <select
    id="maritalStatus"
    name="maritalStatus"
    value={formData.maritalStatus}
    onChange={handleInputChange}
    className={`mt-1 block w-full text-start rounded-xl p-3 bg-gray-50 
      outline-none transition sm:text-sm
      ${
        errors.maritalStatus
          ? "border-2 border-red-500 focus:border-red-500 focus:ring-red-200"
          : "border-2 border-gray-200 focus:border-indigo-600 focus:ring-indigo-100"
      }
    `}
  >
    <option value="">Select Marital Status</option>
    <option value="single">Single</option>
    <option value="married">Married</option>
    <option value="divorced">Divorced</option>
    <option value="widowed">Widowed</option>
    <option value="separated">Separated</option>
    <option value="domesticPartnership">Domestic Partnership</option>
    <option value="preferNotToSay">Prefer not to say</option>
  </select>
</div>


    <div className="text-start">
      <label htmlFor="referredBy" className="block text-sm font-semibold text-slate-700 mb-2">How did you hear about us?</label>
      <select
        id="referredBy"
        name="referredBy"
        value={formData.referredBy}
        onChange={(e) => {
          handleInputChange(e);
          // preserve your DOM-based toggle behavior
          document.getElementById('referredByOtherDetails').style.display =
            e.target.value === 'other' ? 'block' : 'none';
        }}
        className="mt-1 block w-full text-start rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
      >
        <option value="">Select referral source</option>
        <option value="physicianReferral">Physician Referral</option>
        <option value="friendFamily">Friend/Family</option>
        <option value="insurance">Insurance Company</option>
        <option value="internetSearch">Internet Search</option>
        <option value="socialMedia">Social Media</option>
        <option value="advertisement">Advertisement</option>
        <option value="hospitalReferral">Hospital Referral</option>
        <option value="employer">Employer</option>
        <option value="other">Other</option>
      </select>
    </div>
  </div>

  {/* Referred by - other details (keeps your original inline show/hide) */}
  <div
    className="text-start mb-6"
    id="referredByOtherDetails"
    style={{ display: formData.referredBy === 'other' ? 'block' : 'none' }}
  >
    <label htmlFor="referredByOther" className="block text-sm font-semibold text-slate-700 mb-2">Please specify:</label>
    <input
      type="text"
      id="referredByOther"
      name="referredByOther"
      value={formData.referredByOther}
      onChange={handleInputChange}
      placeholder="Please specify how you heard about us"
      className="mt-1 block w-full text-start rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
    />
  </div>

  {/* Phone + Email */}
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
    <div className="text-start">      
      <label htmlFor="phoneNumber"
  className={`block text-sm font-semibold mb-2 ${
    errors.phoneNumber ? "text-red-600" : "text-slate-700"
  }`}>Phone Number *</label>
<input
  type="tel"
  id="phoneNumber"
  name="phoneNumber"
  value={formData.phoneNumber}
  onChange={(e) => {
    const numericValue = e.target.value.replace(/\D/g, ""); // remove non-numbers
    handleInputChange({
      target: { name: "phoneNumber", value: numericValue }
    });
  }}
  required
  pattern="\d{10}"
  maxLength={10}
  inputMode="numeric"
  className={`mt-1 block w-full text-start rounded-xl p-3 bg-gray-50 outline-none transition sm:text-sm
    ${
      errors.phoneNumber
        ? "border-2 border-red-500 focus:border-red-500 focus:ring-red-200"
        : "border-2 border-gray-200 focus:border-indigo-600 focus:ring-indigo-100"
    }
  `}  
/>

    </div>



    <div className="text-start">
      <label htmlFor="email" className={`block text-sm font-semibold text-slate-700 mb-2 ${
    errors.email ? "text-red-600" : "text-slate-700"
  }`}>Email Address *</label>
      <input
        type="email"
        id="email"
        name="email"
        value={formData.email}
        onChange={handleInputChange}
        className={`mt-1 block w-full text-start rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm 
            ${errors.email 
        ? "border-red-500 focus:border-red-500 focus:ring-red-200" 
        : "border-gray-200 focus:border-indigo-600 focus:ring-indigo-100"
    }
`}
      />
    </div>
  </div>

  {/* Address */}
  <div className="text-start mb-6">
    
    <label htmlFor="address"
  className={`block text-sm font-semibold mb-2 ${
    errors.address ? "text-red-600" : "text-slate-700"
  }`}>Address *</label>
    <input
      type="text"
      id="address"
      name="address"
      value={formData.address}
      onChange={handleInputChange}
      placeholder="Street Address"
      required
      className={`mt-1 block w-full text-start rounded-xl p-3 bg-gray-50 outline-none transition sm:text-sm
      ${
        errors.address
          ? "border-2 border-red-500 focus:border-red-500 focus:ring-red-200"
          : "border-2 border-gray-200 focus:border-indigo-600 focus:ring-indigo-100"
      }
    `}
    />
  </div>

  {/* City + ZIP */}
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
    <div className="text-start">      
      <label htmlFor="city"
  className={`block text-sm font-semibold mb-2 ${
    errors.city ? "text-red-600" : "text-slate-700"
  }`}>City *</label>
      <input
        type="text"
        id="city"
        name="city"
        value={formData.city}
        onChange={handleInputChange}
        required
        className={`mt-1 block w-full text-start rounded-xl p-3 bg-gray-50 outline-none transition sm:text-sm
        ${
          errors.city
            ? "border-2 border-red-500 focus:border-red-500 focus:ring-red-200"
            : "border-2 border-gray-200 focus:border-indigo-600 focus:ring-indigo-100"
        }
      `}
      />
    </div>

    <div className="text-start">
      
      <label htmlFor="zipCode"
  className={`block text-sm font-semibold mb-2 ${
    errors.zipCode ? "text-red-600" : "text-slate-700"
  }`}>ZIP Code *</label>
      <input
        type="text"
        id="zipCode"
        name="zipCode"
        value={formData.zipCode}
        onChange={handleInputChange}
        required
        className={`mt-1 block w-full text-start rounded-xl p-3 bg-gray-50 outline-none transition sm:text-sm
      ${
        errors.zipCode
          ? "border-2 border-red-500 focus:border-red-500 focus:ring-red-200"
          : "border-2 border-gray-200 focus:border-indigo-600 focus:ring-indigo-100"
      }
    `}
      />
    </div>
  </div>

  {/* Emergency contact */}
  <div className="text-start mb-6">
    
    <label htmlFor="emergencyContact"
  className={`block text-sm font-semibold mb-2 ${
    errors.emergencyContact ? "text-red-600" : "text-slate-700"
  }`}>Emergency Contact Name *</label>
    <input
      type="text"
      id="emergencyContact"
      name="emergencyContact"
      value={formData.emergencyContact}
      onChange={handleInputChange}
      required
      className={`mt-1 block w-full text-start rounded-xl p-3 bg-gray-50 outline-none transition sm:text-sm
      ${
        errors.emergencyContact
          ? "border-2 border-red-500 focus:border-red-500 focus:ring-red-200"
          : "border-2 border-gray-200 focus:border-indigo-600 focus:ring-indigo-100"
      }
    `}
    />
  </div>

  <div className="text-start mb-6">
  <div className="text-start mb-6">
  <label
    htmlFor="emergencyPhone"
    className={`block text-sm font-semibold mb-2 ${
      errors.emergencyPhone ? "text-red-600" : "text-slate-700"
    }`}
  >
    Emergency Contact Number *
  </label>

  <input
    type="tel"
    id="emergencyPhone"
    name="emergencyPhone"
    value={formData.emergencyPhone}
    onChange={(e) => {
      const numericValue = e.target.value.replace(/\D/g, "");
      handleInputChange({
        target: { name: "emergencyPhone", value: numericValue },
      });
    }}
    required
    pattern="\d{10}"
    maxLength={10}
    inputMode="numeric"
    className={`mt-1 block w-full text-start rounded-xl p-3 bg-gray-50 outline-none transition sm:text-sm
      ${
        errors.emergencyPhone
          ? "border-2 border-red-500 focus:border-red-500 focus:ring-red-200"
          : "border-2 border-gray-200 focus:border-indigo-600 focus:ring-indigo-100"
      }
    `}
  />
</div>


  </div>
</div>}

{currentStep==2 && !isCompleted && <div  className={`${currentStep === 2 ? "block" : "hidden"} space-y-8 text-start`}
  id="step2"
>


      {/* Payment Method Selection */}
      <div className="bg-gradient-to-br from-[#f8faff] to-[#ede9fe] border-2 border-[#c4b5fd] rounded-2xl p-6 mb-7">
        <h3 className="text-[#4f46e5] font-bold text-base mb-1">
          How will you be paying for your visit?
        </h3>
        <p className="text-gray-500 text-xs mb-4">Select one option below.</p>
        <div className="flex gap-3 flex-wrap">
          <label
            className={`flex-1 min-w-[160px] flex items-center gap-3 p-4 border-2 rounded-xl cursor-pointer transition ${
              paymentMethod === "insurance"
                ? "border-indigo-600 bg-white"
                : "border-gray-300 bg-white"
            }`}
          >
            <input
              type="radio"
              name="paymentMethod"
              value="insurance"
              checked={paymentMethod === "insurance"}
              // onChange={() => setPaymentMethod("insurance")}
              onChange={() => {
                setPaymentMethod("insurance");
                setFormData(prev => ({ ...prev, paymentMethod: "insurance" }));
              }}
              className="w-4 h-4 accent-indigo-600"
            />
            <div>
              <div className="font-semibold text-gray-900 text-sm">🏥 Insurance</div>
              <div className="text-xs text-gray-500 mt-1">I have health insurance</div>
            </div>
          </label>

          <label
            className={`flex-1 min-w-[160px] flex items-center gap-3 p-4 border-2 rounded-xl cursor-pointer transition ${
              paymentMethod === "selfpay"
                ? "border-green-600 bg-white"
                : "border-gray-300 bg-white"
            }`}
          >
            <input
              type="radio"
              name="paymentMethod"
              value="selfpay"
              checked={paymentMethod === "selfpay"}
              // onChange={() => setPaymentMethod("selfpay")}
              onChange={() => {
                setPaymentMethod("selfpay");
                setFormData(prev => ({ ...prev, paymentMethod: "selfpay" }));
              }}
              className="w-4 h-4 accent-indigo-600"
            />
            <div>
              <div className="font-semibold text-gray-900 text-sm">💳 Self Pay</div>
              <div className="text-xs text-gray-500 mt-1">I will pay out of pocket</div>
            </div>
          </label>
        </div>
      </div>

      {/* Conditional Render: Self Pay Banner */}
      {paymentMethod === "selfpay" && (
        <div className="bg-green-50 border-2 border-green-500 rounded-xl p-5 mb-7">
          <div className="text-2xl mb-2">✅</div>
          <h4 className="text-green-800 font-bold mb-1 text-base">Self Pay Selected</h4>
          <p className="text-green-700 text-sm leading-6">
            No insurance information is required. Our team will discuss payment
            options and pricing with you at your visit. You can always update this
            later by contacting our office.
          </p>
        </div>
      )}


{/* Conditional Render: Insurance Form */}
      {paymentMethod === "insurance" && (
  <> 
  {/* Primary Insurance Section */}
  <div className="bg-[#fafafa] border-2 border-[#e5e7eb] p-6 rounded-[15px] shadow-md space-y-4">
    <h3 className="text-lg font-semibold text-gray-800">Primary Insurance</h3>

    {/* Row 1 */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="flex flex-col">
        <label htmlFor="primaryInsurance" className="text-sm font-medium text-gray-700">
          Primary Insurance *
        </label>
       <input
  type="text"
  id="primaryInsurance"
  name="primaryInsurance"
  value={formData.primaryInsurance}
  onChange={(e) => {
    const value = e.target.value;
   
      handleInputChange(e);
    
  }}
  required
  className="mt-1 block w-full text-start rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
/>

      </div>

      <div className="flex flex-col">
        <label htmlFor="relationshipToYou" className="text-sm font-medium text-gray-700">
          Relationship to You *
        </label>
        <select
          id="relationshipToYou"
          name="relationshipToYou"
          value={formData.relationshipToYou}
          onChange={handleInputChange}
          required
          className="mt-1 block w-full text-start rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
        >
          <option value="">Select Relationship</option>
          <option value="self">Self</option>
          <option value="spouse">Spouse</option>
          <option value="child">Child</option>
          <option value="parent">Parent</option>
          <option value="other">Other</option>
        </select>
      </div>
    </div>

    {/* Row 2 */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="flex flex-col">
        <label htmlFor="subscriberName" className="text-sm font-medium text-gray-700">
          Subscriber's Name *
        </label>
        <input
          type="text"
          id="subscriberName"
          name="subscriberName"
          value={formData.subscriberName}
          onChange={handleInputChange}
          required
          className="mt-1 block w-full text-start rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
        />
      </div>

      <div className="flex flex-col">
        <label htmlFor="subscriberId" className="text-sm font-medium text-gray-700">
          Subscriber ID *
        </label>
        <input
          type="text"
          id="subscriberId"
          name="subscriberId"
          value={formData.subscriberId}
          onChange={handleInputChange}
          required
          className="mt-1 block w-full text-start rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
        />
      </div>
    </div>

    {/* Row 3 */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
       <div className="flex flex-col">
      <label
        htmlFor="subscriberDOB"
        className="text-sm font-medium text-gray-700 mb-1"
      >
        Date of Birth
      </label>

      <MuiDatePickerField
        label=""
        name="subscriberDOB"
        value={formData.subscriberDOB}
        onChange={handleInputChange}
      />
    </div>

      <div className="flex flex-col">
        <label htmlFor="groupId" className="text-sm font-medium text-gray-700">
          Group ID
        </label>
        <input
          type="text"
          id="groupId"
          name="groupId"
          value={formData.groupId}
          onChange={handleInputChange}
          className="mt-1 block w-full text-start rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
        />
      </div>
    </div>

    {/* SSN */}
    <div className="flex flex-col">
      <label htmlFor="subscriberSSN" className="text-sm font-medium text-gray-700">
        SSN #
      </label>
      <input
        type="number"
        id="subscriberSSN"
        name="subscriberSSN"
        value={formData.subscriberSSN}
        onChange={handleInputChange}
        placeholder="XXX-XX-XXXX"
        className="mt-1 block w-full text-start rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
      />
    </div>

    {/* Insurance Card Upload */}
    <div className="flex flex-col sm:flex-row gap-4">
      <div
        className="flex-1 border-2 border-dashed border-gray-300 rounded-lg p-4 text-center cursor-pointer hover:border-indigo-600"
        onClick={() => document.getElementById("insuranceCardFront").click()}
      >
        <div className="text-gray-600 text-sm">
          <strong className="block">Insurance Card Front Image</strong>
          Click to upload front of card
        </div>
        {/* Preview image shown here */}
  {formData.insuranceCardFrontPreview && (
    <img
      src={formData.insuranceCardFrontPreview}
      alt="Insurance Card Front Preview"
      className="mt-3 mx-auto w-24 h-auto rounded-lg border border-gray-300 shadow-sm"
    />
  )}
      </div>
      <div
        className="flex-1 border-2 border-dashed border-gray-300 rounded-lg p-4 text-center cursor-pointer hover:border-indigo-600"
        onClick={() => document.getElementById("insuranceCardBack").click()}
      >
        <div className="text-gray-600 text-sm">
          <strong className="block">Insurance Card Back Image</strong>
          Click to upload back of card
        </div>
          {formData.insuranceCardBackPreview && (
    <img
      src={formData.insuranceCardBackPreview}
      alt="Insurance Card Back Preview"
      className="mt-3 mx-auto w-24 h-auto rounded-lg border border-gray-300 shadow-sm"
    />
  )}
      </div>
    </div>
<input
  type="file"
  id="insuranceCardFront"
accept="image/*;capture=camera"
  onChange={(e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData(prev => ({
          ...prev,
          insuranceCardFront: file,
          insuranceCardFrontPreview: URL.createObjectURL(file),
          insuranceCardFrontBase64: reader.result, // Base64 string
        }));
      };
      reader.readAsDataURL(file);
    }
  }}
  className="hidden"
/>


<input
  type="file"
  id="insuranceCardBack"
accept="image/*;capture=camera"
  onChange={(e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData(prev => ({
          ...prev,
          insuranceCardBack: file,
          insuranceCardBackPreview: URL.createObjectURL(file),
          insuranceCardBackBase64: reader.result, // Base64 string
        }));
      };
      reader.readAsDataURL(file);
    }
  }}
  className="hidden"
/>


  </div>

<div className="bg-white p-6 rounded-lg shadow-md space-y-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Secondary Insurance</h3>

      {/* Show Add button only if no cards */}
      {formData.secondaryInsurance.length === 0 && (
        <button
          type="button"
          className="px-4 py-2 bg-indigo-600 text-white rounded-md shadow hover:bg-indigo-700"
      onClick={() => addInsuranceCard("secondaryInsurance")}
        >
          + Add Secondary Insurance
        </button>
      )}

      {/* Show card only if it exists */}
      {formData.secondaryInsurance.map((insurance) => (
        <div
          key={insurance.id}
          className="bg-[#fafafa] border-2 border-[#e5e7eb] p-6 rounded-[15px] shadow-md space-y-4 relative"
        >
          <button
            type="button"
            className="absolute top-4 right-4 font-bold rounded px-3 py-1 text-white bg-red-500 hover:bg-red-700"
 onClick={() => removeInsuranceCard("secondaryInsurance", insurance.id)}
            aria-label="Remove Secondary Insurance Card"
          >
            Remove
          </button>

          {/* Form Fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700">Secoundary Insurance *</label>
          <input
  type="text"
  name="primaryInsurance"
  value={insurance.primaryInsurance}
  onChange={(e) => {
    const value = e.target.value;
 
      handleInsuranceChange(e, "secondaryInsurance", insurance.id);
    
  }}
  className="mt-1 block w-full rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
  required
/>

            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700">Relationship to You *</label>
              <select
                name="relationshipToYou"
                value={insurance.relationshipToYou}
            onChange={(e) => handleInsuranceChange(e, "secondaryInsurance", insurance.id)}

                className="mt-1 block w-full rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
                required
              >
                <option value="">Select Relationship</option>
                <option value="self">Self</option>
                <option value="spouse">Spouse</option>
                <option value="child">Child</option>
                <option value="parent">Parent</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700">Subscriber's Name *</label>
              <input
                type="text"
                name="subscriberName"
                value={insurance.subscriberName}
                onChange={(e) => handleInsuranceChange(e, "secondaryInsurance", insurance.id)}
                className="mt-1 block w-full rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
                required
              />
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700">Subscriber ID *</label>
              <input
                type="text"
                name="subscriberId"
                value={insurance.subscriberId}
                onChange={(e) => handleInsuranceChange(e, "secondaryInsurance", insurance.id)}
                className="mt-1 block w-full rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
                required
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700">Date of Birth</label>
             <MuiDatePickerField
    label="" // label handled externally
    name="subscriberDOB"
    value={insurance.subscriberDOB}
    onChange={(e) => handleInsuranceChange(e, "secondaryInsurance", insurance.id)}
    disableFuture={true} // same as max={today}
  />
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700">Group ID</label>
              <input
                type="text"
                name="groupId"
                value={insurance.groupId}
                onChange={(e) => handleInsuranceChange(e, "secondaryInsurance", insurance.id)}
                className="mt-1 block w-full rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
              />
            </div>
          </div>

          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700">SSN #</label>
            <input
              type="number"
              name="subscriberSSN"
              value={insurance.subscriberSSN}
              onChange={(e) => handleInsuranceChange(e, "secondaryInsurance", insurance.id)}
              placeholder="XXX-XX-XXXX"
              className="mt-1 block w-full rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
            />
          </div>

          {/* Insurance Card Uploads */}
          <div className="flex flex-col sm:flex-row gap-4">
            <div
              className="flex-1 border-2 border-dashed border-gray-300 rounded-lg p-4 text-center cursor-pointer hover:border-indigo-600"
              onClick={() =>
                document.getElementById(`secondaryInsuranceCardFront-${insurance.id}`).click()
              }
            >
              <div className="text-gray-600 text-sm">
                <strong className="block">Insurance Card Front Image</strong>
                Click to upload front of card
              </div>
              {insurance.insuranceCardFrontPreview && (
                <img
                  src={insurance.insuranceCardFrontPreview}
                  alt="Insurance Card Front Preview"
                  className="mt-3 mx-auto w-24 h-auto rounded-lg border border-gray-300 shadow-sm"
                />
              )}
            </div>

            <div
              className="flex-1 border-2 border-dashed border-gray-300 rounded-lg p-4 text-center cursor-pointer hover:border-indigo-600"
              onClick={() =>
                document.getElementById(`secondaryInsuranceCardBack-${insurance.id}`).click()
              }
            >
              <div className="text-gray-600 text-sm">
                <strong className="block">Insurance Card Back Image</strong>
                Click to upload back of card
              </div>
              {insurance.insuranceCardBackPreview && (
                <img
                  src={insurance.insuranceCardBackPreview}
                  alt="Insurance Card Back Preview"
                  className="mt-3 mx-auto w-24 h-auto rounded-lg border border-gray-300 shadow-sm"
                />
              )}
            </div>
          </div>

          <input
            type="file"
            id={`secondaryInsuranceCardFront-${insurance.id}`}
            name="insuranceCardFront"
          accept="image/*;capture=camera"
            onChange={(e) => handleInsuranceChange(e, "secondaryInsurance", insurance.id)}
            className="hidden"
          />
          <input
            type="file"
            id={`secondaryInsuranceCardBack-${insurance.id}`}
            name="insuranceCardBack"
           accept="image/*;capture=camera"
            onChange={(e) => handleInsuranceChange(e, "secondaryInsurance", insurance.id)}
            className="hidden"
          />
        </div>
      ))}
    </div>


 <div className="bg-white p-6 rounded-lg shadow-md space-y-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Tertiary Insurance</h3>

      {formData.tertiaryInsurance.length === 0 && (
        <button
          type="button"
          className="px-4 py-2 bg-indigo-600 text-white rounded-md shadow hover:bg-indigo-700"
          onClick={()=>addInsuranceCard("tertiaryInsurance")}
        >
          + Add Tertiary Insurance
        </button>
      )}

      {formData.tertiaryInsurance.map((insurance) => (
        <div
          key={insurance.id}
          className="bg-[#fafafa] border-2 border-[#e5e7eb] p-6 rounded-[15px] shadow-md space-y-4 relative"
        >
          <button
            type="button"
            className="absolute top-4 right-4 font-bold rounded px-3 py-1 text-white bg-red-500 hover:bg-red-700"
            onClick={() => removeInsuranceCard("tertiaryInsurance", insurance.id)}
            aria-label="Remove Tertiary Insurance Card"
          >
            Remove
          </button>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700">Tertiary Insurance *</label>
              <input
                type="text"
                name="primaryInsurance"
                value={insurance.primaryInsurance}
                onChange={(e) =>handleInsuranceChange(e, "tertiaryInsurance",insurance.id)}
                className="mt-1 block w-full rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
                required
              />
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700">Relationship to You *</label>
              <select
                name="relationshipToYou"
                value={insurance.relationshipToYou}
                onChange={(e) => handleInsuranceChange(e, "tertiaryInsurance", insurance.id)}
                className="mt-1 block w-full rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
                required
              >
                <option value="">Select Relationship</option>
                <option value="self">Self</option>
                <option value="spouse">Spouse</option>
                <option value="child">Child</option>
                <option value="parent">Parent</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700">Subscriber's Name *</label>
              <input
                type="text"
                name="subscriberName"
                value={insurance.subscriberName}
                onChange={(e) => handleInsuranceChange(e, "tertiaryInsurance", insurance.id)}
                className="mt-1 block w-full rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
                required
              />
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700">Subscriber ID *</label>
              <input
                type="text"
                name="subscriberId"
                value={insurance.subscriberId}
                onChange={(e) =>handleInsuranceChange(e, "tertiaryInsurance", insurance.id)}
                className="mt-1 block w-full rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
                required
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700">Date of Birth</label>
         <MuiDatePickerField
    label="" // label handled externally
    name="subscriberDOB"
    value={insurance.subscriberDOB}
    onChange={(e) => handleInsuranceChange(e, "tertiaryInsurance", insurance.id)}
    disableFuture={true} // prevents future dates
  />
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700">Group ID</label>
              <input
                type="text"
                name="groupId"
                value={insurance.groupId}
                onChange={(e) => handleInsuranceChange(e, "tertiaryInsurance", insurance.id)}
                className="mt-1 block w-full rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
              />
            </div>
          </div>

          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700">SSN #</label>
            <input
              type="number"
              name="subscriberSSN"
              value={insurance.subscriberSSN}
              onChange={(e) => handleInsuranceChange(e, "tertiaryInsurance", insurance.id)}
              placeholder="XXX-XX-XXXX"
              className="mt-1 block w-full rounded-xl border-2 border-gray-200 bg-gray-50 p-3 focus:border-indigo-600 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition sm:text-sm"
            />
          </div>

          {/* Insurance Card Uploads */}
          <div className="flex flex-col sm:flex-row gap-4">
            <div
              className="flex-1 border-2 border-dashed border-gray-300 rounded-lg p-4 text-center cursor-pointer hover:border-indigo-600"
              onClick={() =>
                document.getElementById(`tertiaryInsuranceCardFront-${insurance.id}`).click()
              }
            >
              <div className="text-gray-600 text-sm">
                <strong className="block">Insurance Card Front Image</strong>
                Click to upload front of card
              </div>
              {insurance.insuranceCardFrontPreview && (
                <img
                  src={insurance.insuranceCardFrontPreview}
                  alt="Insurance Card Front Preview"
                  className="mt-3 mx-auto w-24 h-auto rounded-lg border border-gray-300 shadow-sm"
                />
              )}
            </div>

            <div
              className="flex-1 border-2 border-dashed border-gray-300 rounded-lg p-4 text-center cursor-pointer hover:border-indigo-600"
              onClick={() =>
                document.getElementById(`tertiaryInsuranceCardBack-${insurance.id}`).click()
              }
            >
              <div className="text-gray-600 text-sm">
                <strong className="block">Insurance Card Back Image</strong>
                Click to upload back of card
              </div>
              {insurance.insuranceCardBackPreview && (
                <img
                  src={insurance.insuranceCardBackPreview}
                  alt="Insurance Card Back Preview"
                  className="mt-3 mx-auto w-24 h-auto rounded-lg border border-gray-300 shadow-sm"
                />
              )}
            </div>
          </div>

          <input
            type="file"
            id={`tertiaryInsuranceCardFront-${insurance.id}`}
            name="insuranceCardFront"
         accept="image/*;capture=camera"
            onChange={(e) =>handleInsuranceChange(e, "tertiaryInsurance", insurance.id)}
            className="hidden"
          />
          <input
            type="file"
            id={`tertiaryInsuranceCardBack-${insurance.id}`}
            name="insuranceCardBack"
         accept="image/*;capture=camera"
            onChange={(e) => handleInsuranceChange(e, "tertiaryInsurance", insurance.id)}
            className="hidden"
          />
        </div>
      ))}
    </div>

  {/* Claims Section */}
  <div className="bg-white p-6 rounded-lg shadow-md space-y-4">
    <h3 className="text-lg font-semibold text-gray-800">Have you Claimed for:</h3>

    {/* Workers Comp */}
    <div>
      <label className="text-sm font-medium text-gray-700">Workers Compensation:</label>
      <div className="flex gap-6 mt-1">
        <label className="flex items-center gap-1">
          <input
            type="radio"
            name="workersComp"
            value="yes"
            checked={formData.workersComp === "yes"}
            onChange={handleInputChange}
          />
          Yes
        </label>
        <label className="flex items-center gap-1">
          <input
            type="radio"
            name="workersComp"
            value="no"
            checked={formData.workersComp === "no"}
            onChange={handleInputChange}
          />
          No
        </label>
      </div>
    </div>

    {/* Auto Accident */}
    <div>
      <label className="text-sm font-medium text-gray-700">Auto Accident:</label>
      <div className="flex gap-6 mt-1">
        <label className="flex items-center gap-1">
          <input
            type="radio"
            name="autoAccident"
            value="yes"
            checked={formData.autoAccident === "yes"}
            onChange={handleInputChange}
          />
          Yes
        </label>
        <label className="flex items-center gap-1">
          <input
            type="radio"
            name="autoAccident"
            value="no"
            checked={formData.autoAccident === "no"}
            onChange={handleInputChange}
          />
          No
        </label>
      </div>
    </div>
  </div>

</>
      )}
</div>}

     {currentStep==3 && !isCompleted &&  <div className={`step-content ${currentStep === 3 ? 'block' : 'hidden'}`} id="step3">
  <div className="border border-gray-200 text-start rounded-xl p-6 mb-6 bg-gray-50">
    <h3 className="text-lg font-semibold text-gray-800 mb-4">Present Health Concerns</h3>
  <div className="mb-2">
  <div className="relative mb-2">
    <input
      type="text"
      id="healthConcerns"
      name="healthConcerns"
      placeholder="Enter health concerns"
      autoComplete="off"
      onInput={handleAutocomplete}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === 'Tab') {
          e.preventDefault(); // Prevent form submission or focus jump
          const value = e.target.value.trim();
          if (value && !formData.healthConcerns.includes(value)) {
            setFormData((prev) => ({
              ...prev,
              healthConcerns: [...prev.healthConcerns, value],
            }));
          }
          e.target.value = ''; // Clear input
          document.getElementById('healthSuggestions').style.display = 'none';
        }
      }}
      onBlur={(e) => {
        // Small timeout to allow click on suggestion before blur triggers
        setTimeout(() => {
          const value = e.target.value.trim();
          if (value && !formData.healthConcerns.includes(value)) {
            setFormData((prev) => ({
              ...prev,
              healthConcerns: [...prev.healthConcerns, value],
            }));
          }
          e.target.value = ''; 
          document.getElementById('healthSuggestions').style.display = 'none';
        }, 100);
      }}
      className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base"
    />
    <div
      className="autocomplete-suggestions px-3 cursor-pointer absolute top-full left-0 right-0 bg-white border border-gray-200 rounded-lg shadow-lg max-h-52 overflow-y-auto z-10 hidden"
      id="healthSuggestions"
    />
  </div>

  <div className="flex flex-wrap gap-2 mt-3" id="selectedConcerns">
    {formData.healthConcerns.map((concern, index) => (
      <div
        key={index}
        className="bg-blue-100 text-blue-800 px-3 py-1.5 rounded-full text-sm flex items-center gap-1.5"
      >
        {concern}
        <button
          className="remove-btn bg-transparent border-none text-blue-800 font-bold w-4 h-4 rounded-full flex items-center justify-center hover:bg-blue-800 hover:text-white"
          onClick={() => removeHealthConcern(concern)}
        >
          ×
        </button>
      </div>
    ))}
  </div>
</div>

  </div>
  <div className="border border-gray-200 rounded-xl text-start p-6 mb-6 bg-gray-50">
    <h3 className="text-lg font-semibold text-gray-800 mb-2">Medications</h3>
    <p className="text-gray-500 mb-2 text-sm leading-relaxed">
      Prescription and non-prescription medications, vitamins, home remedies, birth control pills, herbs.
    </p>
  <div className="border border-gray-200 rounded-lg overflow-hidden bg-white mb-5">
  {/* Header */}
  <div className="
      grid 
      grid-cols-1 
      sm:grid-cols-[2fr_1fr_1fr_100px] 
      border-b border-gray-100 bg-gray-50
    "
  >
    <div className="p-3 font-semibold text-sm text-gray-800 border-b sm:border-b-0 sm:border-r border-gray-200">
      MEDICATIONS
    </div>

    <div className="p-3 font-semibold text-sm text-gray-800 border-b sm:border-b-0 sm:border-r border-gray-200">
      DOSE
    </div>

    <div className="p-3 font-semibold text-sm text-gray-800 border-b sm:border-b-0 sm:border-r border-gray-200">
      TIMES PER DAY
    </div>

    <div className="p-3 font-semibold text-sm text-gray-800 text-center">
      ACTION
    </div>
  </div>

  {/* Rows */}
  <div id="medicationsRows">
    {formData.medications.map((med, index) => (
      <div
        key={index}
        className="
          grid 
          grid-cols-1 
          sm:grid-cols-[2fr_1fr_1fr_100px] 
          border-b border-gray-100
        "
      >
        {/* MEDICATION */}
        <div className="p-3 border-b sm:border-b-0 sm:border-r border-gray-100">
          <input
            type="text"
            value={med.medication}
            onChange={(e) =>
              updateTableRow(index, "medication", e.target.value, "medications")
            }
            placeholder="Medication name"
            className="w-full border-none bg-transparent p-1 text-sm focus:outline-none focus:bg-gray-50 focus:p-2 focus:rounded"
          />
        </div>

        {/* DOSE */}
        <div className="p-3 border-b sm:border-b-0 sm:border-r border-gray-100">
          <input
            type="text"
            value={med.dose}
            onChange={(e) =>
              updateTableRow(index, "dose", e.target.value, "medications")
            }
            placeholder="Dose"
            className="w-full border-none bg-transparent p-1 text-sm focus:outline-none focus:bg-gray-50 focus:p-2 focus:rounded"
          />
        </div>

        {/* TIMES PER DAY */}
        <div className="p-3 border-b sm:border-b-0 sm:border-r border-gray-100">
          <input
            type="text"
            value={med.timesPerDay}
            onChange={(e) =>
              updateTableRow(index, "timesPerDay", e.target.value, "medications")
            }
            placeholder="Times per day"
            className="w-full border-none bg-transparent p-1 text-sm focus:outline-none focus:bg-gray-50 focus:p-2 focus:rounded"
          />
        </div>

        {/* ACTION BUTTON */}
        <div className="p-3 flex items-center justify-center">
          <button
            className="bg-red-500 text-white border-none w-6 h-6 rounded-full text-sm flex items-center justify-center hover:bg-red-600 hover:scale-110"
            onClick={() => removeTableRow(index, "medications")}
          >
            ×
          </button>
        </div>
      </div>
    ))}
  </div>
</div>

    <button
      type="button"
      className="bg-indigo-600 text-white border-none px-5 py-2.5 rounded-lg font-semibold text-sm hover:bg-indigo-700 hover:-translate-y-0.5 transition-all mb-5 block"
      onClick={addMedicationRow}
    >
      + Add Row
    </button>
    <div
      className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center cursor-pointer hover:border-indigo-600 hover:bg-gray-50 transition-all mb-4"
      onClick={() => document.getElementById('medicationsUpload').click()}
    >
      <div className="text-gray-400 font-medium text-base">Upload Medications</div>
      <div className="text-gray-500 text-sm">Take photos of your medication bottles/packages</div>
    </div>
    <input
      type="file"
      id="medicationsUpload"
    accept="image/*;capture=camera"
      multiple
      
      onChange={(e) => handleFileChange(e, 'medicationsImages')}
      className="hidden"
    />
    <div className="flex flex-wrap gap-3 mt-4" id="uploadedMedications">
      {formData.medicationsImages.map((img, index) => (
        <div key={index} className="relative rounded-lg overflow-hidden border border-gray-200">
          <img src={URL.createObjectURL(img)} alt="Medication" className="w-20 h-20 object-cover" />
          <button
            className="absolute top-1 right-1 bg-red-500/90 text-white border-none w-5 h-5 rounded-full text-xs flex items-center justify-center"
            onClick={() => removeImage(index, 'medicationsImages')}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  </div>
  <div className="border text-start border-gray-200 rounded-xl p-6  mb-6 bg-gray-50">
    <h3 className="text-lg font-semibold text-gray-800 mb-2">Surgical History</h3>
    <p className="text-gray-500 mb-2 text-sm leading-relaxed">Please list all prior operations and dates:</p>
<div className="border border-gray-200 rounded-lg overflow-hidden bg-white mb-2">
  {/* Header */}
  <div
    className="
      grid 
      grid-cols-1 
      sm:grid-cols-[2fr_1fr_100px] 
      border-b border-gray-100 bg-gray-50
    "
  >
    <div className="p-3 font-semibold text-sm text-gray-800 border-b sm:border-b-0 sm:border-r border-gray-200">
      OPERATION
    </div>

    <div className="p-3 font-semibold text-sm text-gray-800 border-b sm:border-b-0 sm:border-r border-gray-200">
      DATE
    </div>

    <div className="p-3 font-semibold text-sm text-gray-800 text-center">
      ACTION
    </div>
  </div>

  {/* Rows */}
  <div id="surgicalRows">
    {formData.surgicalHistory.map((surgery, index) => (
      <div
        key={index}
        className="
          grid 
          grid-cols-1 
          sm:grid-cols-[2fr_1fr_100px] 
          border-b border-gray-100
        "
      >
        {/* OPERATION */}
        <div className="p-3 border-b sm:border-b-0 sm:border-r border-gray-100">
          <input
            type="text"
            value={surgery.operation}
            onChange={(e) =>
              updateTableRow(index, "operation", e.target.value, "surgicalHistory")
            }
            placeholder="Operation"
            className="w-full border-none bg-transparent p-1 text-sm 
                       focus:outline-none focus:bg-gray-50 focus:p-2 focus:rounded"
          />
        </div>

        {/* DATE PICKER */}
        <div className="p-3 border-b sm:border-b-0 sm:border-r border-gray-100">
          <MuiDatePickerField
            label=""
            name="date"
            value={surgery.date}
            onChange={(e) =>
              updateTableRow(index, "date", e.target.value, "surgicalHistory")
            }
            disableFuture
            size="small"
            fullWidth
            sx={{
              "& .MuiOutlinedInput-root": {
                padding: "2px 8px",
                fontSize: "0.875rem",
              },
            }}
          />
        </div>

        {/* ACTION BUTTON */}
        <div className="p-3 flex items-center justify-center">
          <button
            className="bg-red-500 text-white border-none w-6 h-6 rounded-full text-sm 
                       flex items-center justify-center hover:bg-red-600 hover:scale-110"
            onClick={() => removeTableRow(index, "surgicalHistory")}
          >
            ×
          </button>
        </div>
      </div>
    ))}
  </div>
</div>

    <button
      type="button"
      className="bg-indigo-600 text-white border-none px-5 py-2.5 rounded-lg font-semibold text-sm hover:bg-indigo-700 hover:-translate-y-0.5 transition-all mb-5 block"
      onClick={addSurgicalRow}
    >
      + Add Row
    </button>
  </div>
  <div className="border border-gray-200 rounded-xl p-6 mb-6 bg-gray-50">
    <div className="flex justify-between items-center mb-5 text-base text-gray-800">
      <span>Allergies or Reactions to Medicines/foods/other agents:</span>
      <span className="text-gray-500 text-sm">I am not allergic to any medications</span>
    </div>
<div className="border border-gray-200 rounded-lg overflow-hidden bg-white mb-5">
  {/* Header */}
  <div
    className="
      grid
      grid-cols-1
      sm:grid-cols-[2fr_1fr_100px]
      border-b border-gray-100 bg-gray-50
    "
  >
    <div className="p-3 font-semibold text-sm text-gray-800 border-b sm:border-b-0 sm:border-r border-gray-200">
      MEDICATIONS/FOOD/OTHER AGENTS
    </div>

    <div className="p-3 font-semibold text-sm text-gray-800 border-b sm:border-b-0 sm:border-r border-gray-200">
      REACTION OR SIDE EFFECT
    </div>

    <div className="p-3 font-semibold text-sm text-gray-800 text-center">
      ACTION
    </div>
  </div>

  {/* Rows */}
  <div id="allergiesRows">
    {formData.allergies.map((allergy, index) => (
      <div
        key={index}
        className="
          grid
          grid-cols-1
          sm:grid-cols-[2fr_1fr_100px]
          border-b border-gray-100
        "
      >
        {/* Agent */}
        <div className="p-3 border-b sm:border-b-0 sm:border-r border-gray-100">
          <input
            type="text"
            value={allergy.agent}
            onChange={(e) =>
              updateTableRow(index, "agent", e.target.value, "allergies")
            }
            placeholder="Agent"
            className="w-full border-none bg-transparent p-1 text-sm 
                       focus:outline-none focus:bg-gray-50 focus:p-2 focus:rounded"
          />
        </div>

        {/* Reaction */}
        <div className="p-3 border-b sm:border-b-0 sm:border-r border-gray-100">
          <input
            type="text"
            value={allergy.reaction}
            onChange={(e) =>
              updateTableRow(index, "reaction", e.target.value, "allergies")
            }
            placeholder="Reaction"
            className="w-full border-none bg-transparent p-1 text-sm 
                       focus:outline-none focus:bg-gray-50 focus:p-2 focus:rounded"
          />
        </div>

        {/* Action */}
        <div className="p-3 flex items-center justify-center">
          <button
            className="bg-red-500 text-white border-none w-6 h-6 rounded-full text-sm 
                       flex items-center justify-center hover:bg-red-600 hover:scale-110"
            onClick={() => removeTableRow(index, "allergies")}
          >
            ×
          </button>
        </div>
      </div>
    ))}
  </div>
</div>

    <button
      type="button"
      className="bg-indigo-600 text-white border-none px-5 py-2.5 rounded-lg font-semibold text-sm hover:bg-indigo-700 hover:-translate-y-0.5 transition-all mb-5 block"
      onClick={addAllergyRow}
    >
      + Add Row
    </button>
  </div>
  <div className="border text-start border-gray-200 rounded-xl p-6 mb-6 bg-gray-50">
    <h3 className="text-lg font-semibold text-gray-800 mb-5">Personal Medical History</h3>
    <div className="bg-blue-50 border border-blue-500 rounded-lg p-4 mb-6">
 <label className="relative flex items-start cursor-pointer mb-3 text-sm leading-snug pl-7">
  <input
    type="checkbox"
    id="noneOfTheBelow"
    name="noFamilyHistory"
    checked={formData.noFamilyHistory}
    onChange={(e) => {
      handleInputChange(e);
      toggleMedicalHistory();
    }}
    className="absolute opacity-0 w-0 h-0"
  />
  <span className="absolute left-0 top-0.5 w-5 h-5 bg-white border-2 border-gray-300 rounded transition-all hover:border-indigo-600
  checked:bg-indigo-600 checked:border-indigo-600
  flex items-center justify-center"
>
  {formData.noFamilyHistory && (
    <svg
      className="w-3 h-3 text-indigo-600"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
  )}
</span>

  None of the below
</label>

    </div>
    <div
      className={`transition-all ${formData.noFamilyHistory ? 'opacity-40 pointer-events-none' : ''}`}
      id="medicalHistoryContainer"
    >
      <p className="text-gray-500 mb-5 text-sm leading-relaxed">
        Do you have any of the following problems?
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div className="flex flex-col">
          {[
            { name: 'acidReflux', label: 'Acid reflux/heartburn' },
            { name: 'alcoholism', label: 'Alcoholism/other addictions' },
            { name: 'environmentalAllergies', label: 'Allergies (environmental)' },
            { name: 'anxiety', label: 'Anxiety' },
            { name: 'asthma', label: 'Asthma' },
            { name: 'atrialFibrillation', label: 'Atrial Fibrillation' },
            { name: 'cancer', label: 'Cancer' },
            { name: 'bleedingDisorders', label: 'Bleeding or clotting disorders' },
            { name: 'highCholesterol', label: 'High Cholesterol' },
            { name: 'depression', label: 'Depression/Suicide attempt' },
            { name: 'diabetes', label: 'Diabetes Mellitus' },
          ].map((condition) => (
      <label className="flex items-center mb-3 text-sm cursor-pointer">
  <input
    type="checkbox"
    name={condition.name}
    checked={formData.medicalHistory.includes(condition.name)}
    onChange={handleInputChange}
    className="w-5 h-5 text-indigo-600 bg-white border-2 border-gray-300 rounded focus:ring-2 focus:ring-indigo-300 focus:outline-none cursor-pointer"
  />
  <span className="ml-2">{condition.label}</span>
</label>


          ))}
        </div>
       <div className="flex flex-col">
  {[
    { name: 'erectileDysfunction', label: 'Erectile dysfunction' },
    { name: 'congenitalHeartDisease', label: 'Congenital heart disease' },
    { name: 'hypertension', label: 'Hypertension (high blood pressure)' },
    { name: 'irritableBowel', label: 'Irritable bowel syndrome' },
    { name: 'migraines', label: 'Migraines' },
    { name: 'osteopenia', label: 'Osteopenia or Osteoporosis' },
    { name: 'prostateProblem', label: 'Prostate problem' },
    { name: 'thyroidProblem', label: 'Thyroid problem' },
    { name: 'abnormalPapSmear', label: 'Abnormal pap smear' },
    { name: 'otherProblem', label: 'Other problem (list below)' },
  ].map((condition) => (
    <label
      key={condition.name}
      className="relative flex items-start cursor-pointer mb-3 text-sm leading-snug pl-7"
    >
      <input
        type="checkbox"
        name={condition.name}
        checked={formData.medicalHistory.includes(condition.name)}
        onChange={(e) => {
          const { checked, name } = e.target;
          let updatedMedicalHistory = [...formData.medicalHistory];
          if (checked) {
            if (!updatedMedicalHistory.includes(name)) {
              updatedMedicalHistory.push(name);
            }
          } else {
            updatedMedicalHistory = updatedMedicalHistory.filter(item => item !== name);
          }
          setFormData(prev => ({
            ...prev,
            medicalHistory: updatedMedicalHistory,
          }));
        }}
        className="w-5 h-5 text-indigo-600 bg-white border-2 border-gray-300 rounded focus:ring-2 focus:ring-indigo-300 focus:outline-none cursor-pointer"
      />
      {/* <span
        className="absolute left-0 top-0.5 w-5 h-5 bg-white border-2 border-gray-300 rounded transition-all
          peer-checked:bg-indigo-600 peer-checked:border-indigo-600 flex items-center justify-center"
      >
        <svg
          className="w-3 h-3 text-white opacity-0 peer-checked:opacity-100 transition-opacity"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      </span> */}
      <span className="ml-2">{condition.label}</span>      
    </label>
  ))}
</div>

      </div>
      <div className="mb-6 mt-5">
        <input
          type="text"
          id="otherProblemDetails"
          name="otherProblemDetails"
          value={formData.otherProblemDetails}
          onChange={handleInputChange}
          placeholder="Please specify other problems"
          className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base"
        />
      </div>
      <div className="border-t border-gray-200 pt-6">
        <h4 className="text-base font-semibold text-gray-800 mb-4">Have you had any of the following problems? If so please provide approximate year:</h4>
        <div className="grid gap-3">
  {[
    { label: "Cancer", name: "cancerYear" },
    { label: "Heart Attack (MI)", name: "heartAttackYear" },
    { label: "Blood Transfusion", name: "bloodTransfusionYear" },
    { label: "Stroke (CVA)", name: "strokeYear" },
    { label: "Seizure", name: "seizureYear" },
  ].map((condition) => (
    <div
      key={condition.name}
      className="
        grid 
        grid-cols-1 
        sm:grid-cols-[200px_1fr] 
        items-center 
        gap-2 sm:gap-4
      "
    >
      <label className="font-medium text-sm text-gray-800">
        {condition.label}
      </label>

      <input
        type="text"
        name={condition.name}
        value={formData.seriousConditions[condition.name]}
        onChange={handleInputChange}
        placeholder="Year"
        className="
          p-2 
          border border-gray-300 
          rounded-md 
          text-sm 
          focus:outline-none 
          focus:border-indigo-600 
          focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)]
        "
      />
    </div>
  ))}
</div>

      </div>
    </div>
  </div>
  <div
    className={`border border-gray-200 text-start rounded-xl p-6 mb-6 bg-gray-50 ${formData.gender === 'female' ? 'block' : 'hidden'}`}
    id="gynecologicHistory"
  >
    <h3 className="text-lg font-semibold text-gray-800 mb-5">Women's Gynecologic History</h3>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="mb-6">
        <label htmlFor="pregnancies" className="block font-semibold text-gray-800 text-sm mb-2">Pregnancies:</label>
        <input
          type="number"
          id="pregnancies"
          name="pregnancies"
          value={formData.gynecologicHistory.pregnancies}
          onChange={handleInputChange}
          className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base"
        />
      </div>
      <div className="mb-6">
        <label htmlFor="deliveries" className="block font-semibold text-gray-800 text-sm mb-2">Deliveries:</label>
        <input
          type="number"
          id="deliveries"
          name="deliveries"
          value={formData.gynecologicHistory.deliveries}
          onChange={handleInputChange}
          className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base"
        />
      </div>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="mb-6">
        <label htmlFor="abortions" className="block font-semibold text-gray-800 text-sm mb-2">Abortions:</label>
        <input
          type="number"
          id="abortions"
          name="abortions"
          value={formData.gynecologicHistory.abortions}
          onChange={handleInputChange}
          className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base"
        />
      </div>
      <div className="mb-6">
        <label htmlFor="miscarriages" className="block font-semibold text-gray-800 text-sm mb-2">Miscarriages:</label>
        <input
          type="number"
          id="miscarriages"
          name="miscarriages"
          value={formData.gynecologicHistory.miscarriages}
          onChange={handleInputChange}
          className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base"
        />
      </div>
    </div>
    <div className="mb-6">
      <label htmlFor="lastPeriodDate" className="block font-semibold text-gray-800 text-sm mb-2">Date of last period:</label>
        <MuiDatePickerField
    label="" // label handled externally
    name="lastPeriodDate"
    value={formData.gynecologicHistory.lastPeriodDate}
    onChange={handleInputChange}
    disableFuture={true} // prevents selecting future dates
    fullWidth
    size="small"
    sx={{
      "& .MuiOutlinedInput-root": {
        padding: "12px", // match original p-3.5
        fontSize: "1rem",
      },
    }}
  />
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="mb-6">
        <label htmlFor="ageOfFirstPeriod" className="block font-semibold text-gray-800 text-sm mb-2">Age of 1st Period:</label>
        <input
          type="number"
          id="ageOfFirstPeriod"
          name="ageOfFirstPeriod"
          value={formData.gynecologicHistory.ageOfFirstPeriod}
          onChange={handleInputChange}
          className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base"
        />
      </div>
      <div className="mb-6">
        <label htmlFor="periodFrequency" className="block font-semibold text-gray-800 text-sm mb-2">Frequency of Periods:</label>
        <input
          type="text"
          id="periodFrequency"
          name="periodFrequency"
          value={formData.gynecologicHistory.periodFrequency}
          onChange={handleInputChange}
          className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base"
        />
      </div>
    </div>
    <div className="mb-6">
      <label htmlFor="periodLength" className="block font-semibold text-gray-800 text-sm mb-2">Length:</label>
      <input
        type="text"
        id="periodLength"
        name="periodLength"
        value={formData.gynecologicHistory.periodLength}
        onChange={handleInputChange}
        className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base"
      />
    </div>
    <div className="mb-6">
      <label className="block font-semibold text-gray-800 text-sm mb-2">Do you have any concerns about your periods?</label>
      <div className="flex gap-5 flex-wrap">
        <label className="flex items-center cursor-pointer">
          <input
            type="radio"
            name="periodConcerns"
            value="yes"
            checked={formData.gynecologicHistory.periodConcerns === 'yes'}
            onChange={(e) => {
              handleInputChange(e);
              togglePeriodConcerns();
            }}
            className="mr-1.5"
          /> Yes
        </label>
        <label className="flex items-center cursor-pointer">
          <input
            type="radio"
            name="periodConcerns"
            value="no"
            checked={formData.gynecologicHistory.periodConcerns === 'no'}
            onChange={(e) => {
              handleInputChange(e);
              togglePeriodConcerns();
            }}
            className="mr-1.5"
          /> No
        </label>
      </div>
    </div>
    <div
      className={`mb-6 ${formData.gynecologicHistory.periodConcerns === 'yes' ? 'block' : 'hidden'}`}
      id="periodConcernsExplain"
    >
      <label htmlFor="periodConcernsExplainText" className="block font-semibold text-gray-800 text-sm mb-2">If yes, please explain:</label>
      <textarea
        id="periodConcernsExplainText"
        name="periodConcernsExplainText"
        rows={3}
        value={formData.gynecologicHistory.periodConcernsExplainText}
        onChange={handleInputChange}
        className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)]"
      />
    </div>
  </div>
</div>}
   {currentStep==4 && !isCompleted && <div className={`step-content ${currentStep === 4 ? 'block' : 'hidden'}`} id="step4">
  <div className="border border-gray-200 rounded-xl p-6 mb-6 bg-gray-50">
    <h3 className="text-lg font-semibold text-gray-800 mb-5 text-start">Family History</h3>
    <div className="mb-6">
 <label className="relative flex items-center cursor-pointer mb-3 text-sm leading-snug pl-2 text-start">
  <input
    type="checkbox"
    id="noFamilyHistory"
    name="noFamilyHistory"
    checked={formData.noFamilyHistory}
    onChange={(e) => {
      handleInputChange(e);
      toggleFamilyHistoryTable();
    }}
    className="mr-2 cursor-pointer"
  />
  I do not know my family history
</label>


    </div>
   <div
  id="familyHistoryContainer"
  className="transition-all"
  style={{
    opacity: formData.noFamilyHistory ? 0.5 : 1,
    pointerEvents: formData.noFamilyHistory ? 'none' : 'auto',
  }}
>
      <p className="text-gray-500 mb-2 text-sm leading-relaxed text-start">
        Please indicate with a check (✓) family members who have had any of the following conditions:
      </p>
       <div className="overflow-x-auto w-full">
  <table className="min-w-max w-full border-collapse mt-2 text-sm text-gray-800">
    <thead>
      <tr>
        <th className="border border-gray-200 p-2.5 text-start bg-gray-100 font-semibold">Medical Condition</th>
        <th className="border border-gray-200 p-2.5 text-center bg-gray-100 font-semibold w-[70px]">Mom</th>
        <th className="border border-gray-200 p-2.5 text-center bg-gray-100 font-semibold w-[70px]">Dad</th>
        <th className="border border-gray-200 p-2.5 text-center bg-gray-100 font-semibold w-[70px]">Brother</th>
        <th className="border border-gray-200 p-2.5 text-center bg-gray-100 font-semibold w-[70px]">Sister</th>
        <th className="border border-gray-200 p-2.5 text-center bg-gray-100 font-semibold w-[70px]">Grandmother</th>
        <th className="border border-gray-200 p-2.5 text-center bg-gray-100 font-semibold w-[70px]">Grandfather</th>
        <th className="border border-gray-200 p-2.5 text-center bg-gray-100 font-semibold w-[70px]">Son</th>
        <th className="border border-gray-200 p-2.5 text-center bg-gray-100 font-semibold w-[70px]">Daughter</th>
        <th className="border border-gray-200 p-2.5 text-center bg-gray-100 font-semibold w-[70px]">Other</th>
      </tr>
    </thead>

    <tbody>
      {[
        "Alcoholism",
        "Anemia",
        "Hay Fever",
        "Asthma",
        "Arthritis",
        "High Blood Pressure",
        "Coronary Artery Disease",
        "High Cholesterol",
        "Cancer, Breast",
        "Cancer, Colon",
        "Cancer, Ovary",
        "Cancer, Prostate",
        "Mitral Valve Prolapse",
        "Migraine Headaches",
        "Osteoporosis",
        "Diabetes",
        "Depression",
        "Thyroid Disorders",
        "Stroke",
        "Seizures",
      ].map((condition) => (
        <tr key={condition}>
          <td className="border border-gray-200 p-2.5 bg-white font-semibold w-[200px] text-start">
            {condition}
          </td>

          {["Mom","Dad","Brother","Sister","GM","GF","Son","Daughter","Other"].map((relative) => (
            <td key={relative} className="border border-gray-200 p-2.5 bg-white text-center w-[70px]">
              <input
                type="checkbox"
                name={`${condition.toLowerCase().replace(/, /g, "").replace(/ /g, "")}${relative}`}
                checked={
                  formData.familyHistory[
                    `${condition.toLowerCase().replace(/, /g, "").replace(/ /g, "")}${relative}`
                  ] || false
                }
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    familyHistory: {
                      ...prev.familyHistory,
                      [`${condition.toLowerCase().replace(/, /g, "").replace(/ /g, "")}${relative}`]:
                        e.target.checked,
                    },
                  }))
                }
                className="cursor-pointer"
              />
            </td>
          ))}
        </tr>
      ))}

      <tr>
        <td className="border border-gray-200 p-2.5 bg-white font-semibold w-[200px] text-start">
          Other:
        </td>
        <td colSpan={10} className="border border-gray-200 p-2.5 bg-white">
          <input
            type="text"
            name="otherFamilyHistory"
            value={formData.familyHistory.otherFamilyHistory || ""}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                familyHistory: {
                  ...prev.familyHistory,
                  otherFamilyHistory: e.target.value,
                },
              }))
            }
            placeholder="Please specify other family history"
            className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 
                       focus:outline-none focus:border-indigo-600 focus:bg-white 
                       focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base"
          />
        </td>
      </tr>
    </tbody>
  </table>
</div>

    </div>
  </div>
</div>}
          {currentStep==5 && !isCompleted && <div className={`step-content ${currentStep === 5 ? 'block' : 'hidden'}`} id="step5">
  <div className="border border-gray-200 rounded-xl p-3 sm:p-4 md:p-6 mb-6 bg-gray-50"
>
    <h3 className="text-lg font-semibold text-gray-800 mb-5 text-start">Social History</h3>
    <p className="text-gray-500 mb-5 text-sm leading-relaxed text-start">Please check all that apply.</p>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
      <div className="bg-white border border-gray-200 rounded-xl p-3 sm:p-4 md:p-5"
>
        <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Tobacco Use</h4>
        <div className="mb-6">
          <div className="flex flex-col gap-2">
            {[
              { value: 'never', label: 'I have never smoked' },
              { value: 'rarely', label: 'I have smoked, but rarely.' },
              { value: 'currently', label: 'I currently smoke' },
              { value: 'quit', label: 'I have quit smoking' },
            ].map((option) => (
              <label key={option.value} className="flex items-center cursor-pointer text-sm text-start">
                <input
                  type="radio"
                  name="tobaccoUse"
                  value={option.value}
                  checked={formData.tobaccoUse === option.value}
                  onChange={(e) => {
                    handleInputChange(e);
                    toggleTobaccoQuestions(e.target.value !== 'never');
                  }}
                  className="w-4 h-4 mr-2"
                />
                {option.label}
              </label>
            ))}
          </div>
        </div>
        <div
          id="tobaccoQuestions"
          className={`mb-6 ${formData.tobaccoUse !== 'never' ? 'block' : 'hidden'}`}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="lastTimeSmoked" className="block font-semibold text-gray-800 text-sm mb-2 text-start">When was the last time?</label>
              <input
                type="text"
                id="lastTimeSmoked"
                name="lastTimeSmoked"
                value={formData.tobaccoQuestions.lastTimeSmoked}
                onChange={handleInputChange}
                className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
              />
            </div>
            <div>
              <label htmlFor="quitDate" className="block font-semibold text-gray-800 text-sm mb-2 text-start">Quit date</label>
                 <style>
{`
  .MuiFormControl-root {
    width: 100% !important;
  }
  .MuiInputBase-root {
    width: 100% !important;
  }
`}
</style>
             <MuiDatePickerField
    label="" // label handled externally
    name="quitDate"
    value={formData.tobaccoQuestions.quitDate}
    onChange={handleInputChange}
    disableFuture={true} // prevents selecting future dates
    fullWidth
    size="small"
    {...{
      sx: {
        "& .MuiOutlinedInput-root": {
          padding: "12px", // match your original p-3.5
          fontSize: "1rem",
        },
      },
    }}
  />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            <div>
              <label htmlFor="packsPerDay" className="block font-semibold text-gray-800 text-sm mb-2 text-start">I currently smoke pack(s)/day, # of</label>
              <input
                type="number"
                id="packsPerDay"
                name="packsPerDay"
                value={formData.tobaccoQuestions.packsPerDay}
                onChange={handleInputChange}
                className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
              />
            </div>
            <div>
              <label htmlFor="yearsSmoking" className="block font-semibold text-gray-800 text-sm mb-2 text-start">Years</label>
              <input
                type="number"
                id="yearsSmoking"
                name="yearsSmoking"
                value={formData.tobaccoQuestions.yearsSmoking}
                onChange={handleInputChange}
                className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
              />
            </div>
          </div>
          <div className="mt-4">
            <label htmlFor="otherTobacco" className="block font-semibold text-gray-800 text-sm mb-2 text-start">Other</label>
            <input
              type="text"
              id="otherTobacco"
              name="otherTobacco"
              value={formData.tobaccoQuestions.otherTobacco}
              onChange={handleInputChange}
              className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
            />
          </div>
          <div className="mt-4">
            <label className="block font-semibold text-gray-800 text-sm mb-2 text-start">Are you interested in quitting?</label>
            <div className="flex gap-5 flex-wrap">
              <label className="flex items-center cursor-pointer text-start">
                <input
                  type="radio"
                  name="interestedInQuitting"
                  value="yes"
                  checked={formData.tobaccoQuestions.interestedInQuitting === 'yes'}
                  onChange={handleInputChange}
                  className="mr-1.5"
                /> Yes
              </label>
              <label className="flex items-center cursor-pointer text-start">
                <input
                  type="radio"
                  name="interestedInQuitting"
                  value="no"
                  checked={formData.tobaccoQuestions.interestedInQuitting === 'no'}
                  onChange={handleInputChange}
                  className="mr-1.5"
                /> No
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white border border-gray-200 rounded-xl p-3 sm:p-4 md:p-5"
>
        <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Alcohol Use</h4>
        <div className="mb-6">
          <label className="block font-semibold text-gray-800 text-sm mb-2 text-start">Do you drink alcohol?</label>
          <div className="flex flex-col gap-2">
            {[
              { value: 'never', label: 'Never' },
              { value: 'occasionally', label: 'Occasionally' },
              { value: 'regularly', label: 'Regularly' },
            ].map((option) => (
              <label key={option.value} className="flex items-center cursor-pointer text-sm text-start">
                <input
                  type="radio"
                  name="alcoholUse"
                  value={option.value}
                  checked={formData.alcoholUse === option.value}
                  onChange={(e) => {
                    handleInputChange(e);
                    toggleAlcoholQuestions(e.target.value !== 'never');
                  }}
                  className="w-4 h-4 mr-2"
                />
                {option.label}
              </label>
            ))}
          </div>
        </div>
        <div
          id="alcoholQuestions"
          className={`mb-6 ${formData.alcoholUse !== 'never' ? 'block' : 'hidden'}`}
        >
          <label htmlFor="alcoholPerWeek" className="block font-semibold text-gray-800 text-sm mb-2 text-start">Average #drinks/week</label>
          <input
            type="text"
            id="alcoholPerWeek"
            name="alcoholPerWeek"
            value={formData.alcoholQuestions.alcoholPerWeek}
            onChange={handleInputChange}
            placeholder="e.g., 5oz glasses wine, 12 oz can beer, 1.5 oz shots hard liquor"
            className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
          />
          <label className="block font-semibold text-gray-800 text-sm mb-2 mt-4 text-start">Is alcohol use a concern for you or others?</label>
          <div className="flex gap-5 flex-wrap">
            <label className="flex items-center cursor-pointer text-start">
              <input
                type="radio"
                name="alcoholConcern"
                value="yes"
                checked={formData.alcoholQuestions.alcoholConcern === 'yes'}
                onChange={handleInputChange}
                className="mr-1.5"
              /> Yes
            </label>
            <label className="flex items-center cursor-pointer text-start">
              <input
                type="radio"
                name="alcoholConcern"
                value="no"
                checked={formData.alcoholQuestions.alcoholConcern === 'no'}
                onChange={handleInputChange}
                className="mr-1.5"
              /> No
            </label>
          </div>
        </div>
        <h4 className="text-base font-semibold text-gray-800 mb-4 mt-6 text-start">Drug Use</h4>
        <div className="mb-6">
          <label className="block font-semibold text-gray-800 text-sm mb-2 text-start">Do you use any recreational drugs?</label>
          <div className="flex gap-5 flex-wrap">
            <label className="flex items-center cursor-pointer text-start">
              <input
                type="radio"
                name="recreationalDrugs"
                value="yes"
                checked={formData.recreationalDrugs === 'yes'}
                onChange={(e) => {
                  handleInputChange(e);
                  toggleDrugQuestions(e.target.value === 'yes');
                }}
                className="mr-1.5"
              /> Yes
            </label>
            <label className="flex items-center cursor-pointer text-start">
              <input
                type="radio"
                name="recreationalDrugs"
                value="no"
                checked={formData.recreationalDrugs === 'no'}
                onChange={(e) => {
                  handleInputChange(e);
                  toggleDrugQuestions(e.target.value === 'yes');
                }}
                className="mr-1.5"
              /> No
            </label>
          </div>
        </div>
        <div
          id="drugQuestions"
          className={`mb-6 ${formData.recreationalDrugs === 'yes' ? 'block' : 'hidden'}`}
        >
          <label className="block font-semibold text-gray-800 text-sm mb-2 text-start">Have you ever used needles?</label>
          <div className="flex gap-5 flex-wrap">
            <label className="flex items-center cursor-pointer text-start">
              <input
                type="radio"
                name="usedNeedles"
                value="yes"
                checked={formData.drugQuestions.usedNeedles === 'yes'}
                onChange={handleInputChange}
                className="mr-1.5"
              /> Yes
            </label>
            <label className="flex items-center cursor-pointer text-start">
              <input
                type="radio"
                name="usedNeedles"
                value="no"
                checked={formData.drugQuestions.usedNeedles === 'no'}
                onChange={handleInputChange}
                className="mr-1.5"
              /> No
            </label>
          </div>
        </div>
      </div>
      <div className="bg-white border border-gray-200 rounded-xl p-3 sm:p-4 md:p-5"
>
        <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Sexuality</h4>
        <div className="mb-6">
          <label className="block font-semibold text-gray-800 text-sm mb-2 text-start">Sexual Active</label>
          <div className="flex flex-col gap-2">
            {[
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' },
              { value: 'notCurrently', label: 'Not Currently' },
            ].map((option) => (
              <label key={option.value} className="flex items-center cursor-pointer text-sm text-start">
                <input
                  type="radio"
                  name="sexualActive"
                  value={option.value}
                  checked={formData.sexualActive === option.value}
                  onChange={(e) => {
                    handleInputChange(e);
                    toggleSexualityQuestions(e.target.value !== 'no');
                  }}
                  className="w-4 h-4 mr-2"
                />
                {option.label}
              </label>
            ))}
          </div>
        </div>
        <div
          id="sexualityQuestions"
          className={`mb-6 ${formData.sexualActive !== 'no' ? 'block' : 'hidden'}`}
        >
          <label htmlFor="sexPartnerGender" className="block font-semibold text-gray-800 text-sm mb-2 text-start">Current Sex Partner is/are:</label>
          <div className="flex gap-5 flex-wrap">
            <label className="flex items-center cursor-pointer text-start">
              <input
                type="radio"
                name="sexPartnerGender"
                value="male"
                checked={formData.sexualityQuestions.sexPartnerGender === 'male'}
                onChange={handleInputChange}
                className="mr-1.5"
              /> Male
            </label>
            <label className="flex items-center cursor-pointer text-start">
              <input
                type="radio"
                name="sexPartnerGender"
                value="female"
                checked={formData.sexualityQuestions.sexPartnerGender === 'female'}
                onChange={handleInputChange}
                className="mr-1.5"
              /> Female
            </label>
            <label className="flex items-center cursor-pointer text-start">
              <input
                type="radio"
                name="sexPartnerGender"
                value="intersex"
                checked={formData.sexualityQuestions.sexPartnerGender === 'intersex'}
                onChange={handleInputChange}
                className="mr-1.5"
              /> Intersex
            </label>
            <label className="flex items-center cursor-pointer text-start">
              <input
                type="radio"
                name="sexPartnerGender"
                value="prefer not to say"
                checked={formData.sexualityQuestions.sexPartnerGender === 'prefer not to say'}
                onChange={handleInputChange}
                className="mr-1.5"
              /> Prefer not to say
            </label>
          </div>
          <div className="mt-4">
            <label className="block font-semibold text-gray-800 text-sm mb-2 text-start">Have you ever had any sexually transmitted Disease (STD's)?</label>
            <div className="flex gap-5 flex-wrap">
              <label className="flex items-center cursor-pointer text-start">
                <input
                  type="radio"
                  name="hasSTD"
                  value="yes"
                  checked={formData.sexualityQuestions.hasSTD === 'yes'}
                  onChange={(e) => {
                    handleInputChange(e);
                    toggleSTDExplanation(e.target.value === 'yes');
                  }}
                  className="mr-1.5"
                /> Yes
              </label>
              <label className="flex items-center cursor-pointer text-start">
                <input
                  type="radio"
                  name="hasSTD"
                  value="no"
                  checked={formData.sexualityQuestions.hasSTD === 'no'}
                  onChange={(e) => {
                    handleInputChange(e);
                    toggleSTDExplanation(e.target.value === 'yes');
                  }}
                  className="mr-1.5"
                /> No
              </label>
            </div>
          </div>
          <div
            id="stdExplanation"
            className={`mt-4 ${formData.sexualityQuestions.hasSTD === 'yes' ? 'block' : 'hidden'}`}
          >
            <label htmlFor="stdDetails" className="block font-semibold text-gray-800 text-sm mb-2 text-start">If yes, please include:</label>
            <input
              type="text"
              id="stdDetails"
              name="stdDetails"
              value={formData.sexualityQuestions.stdDetails}
              onChange={handleInputChange}
              className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
            />
            <label htmlFor="stdDate" className="block font-semibold text-gray-800 text-sm mb-2 mt-4 text-start">date</label>
           <MuiDatePickerField
    label="" // label handled externally
    name="stdDate"
    value={formData.sexualityQuestions.stdDate}
    onChange={handleInputChange}
    disableFuture={true} // prevents selecting future dates
    fullWidth
    size="small"
    sx={{
      "& .MuiOutlinedInput-root": {
        padding: "12px", // matches original p-3.5
        fontSize: "1rem",
      },
    }}
  />
          </div>
          <div className="mt-4">
            <label htmlFor="birthControl" className="block font-semibold text-gray-800 text-sm mb-2 text-start">Contraception and Protection:</label>
            <input
              type="text"
              id="birthControl"
              name="birthControl"
              value={formData.sexualityQuestions.birthControl}
              onChange={handleInputChange}
              className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
            />
          </div>
          <div className="mt-4">
            <label className="block font-semibold text-gray-800 text-sm mb-2 text-start">If sexually active, do you practice safe sex?</label>
            <div className="flex gap-5 flex-wrap">
              <label className="flex items-center cursor-pointer text-start">
                <input
                  type="radio"
                  name="safeSex"
                  value="yes"
                  checked={formData.sexualityQuestions.safeSex === 'yes'}
                  onChange={handleInputChange}
                  className="mr-1.5"
                /> Yes
              </label>
              <label className="flex items-center cursor-pointer text-start">
                <input
                  type="radio"
                  name="safeSex"
                  value="no"
                  checked={formData.sexualityQuestions.safeSex === 'no'}
                  onChange={handleInputChange}
                  className="mr-1.5"
                /> No
              </label>
              <label className="flex items-center cursor-pointer text-start">
                <input
                  type="radio"
                  name="safeSex"
                  value="na"
                  checked={formData.sexualityQuestions.safeSex === 'na'}
                  onChange={handleInputChange}
                  className="mr-1.5"
                /> N/A
              </label>
            </div>
          </div>
        </div>
        <h4 className="text-base font-semibold text-gray-800 mb-4 mt-6 text-start">Socioeconomics</h4>
        <div className="mb-6">
          <label htmlFor="ethnicBackground" className="block font-semibold text-gray-800 text-sm mb-2 text-start">Ethnic Background:</label>
          <select
            id="ethnicBackground"
            name="ethnicBackground"
            value={formData.ethnicBackground}
            onChange={handleInputChange}
            className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
          >
            <option value="">Select</option>
            <option value="asian">Asian</option>
            <option value="black">Black</option>
            <option value="nonHispanicWhite">Non Hispanic, Hispanic</option>
            <option value="nativeAmerican">Native American</option>
            <option value="nativeHawaiian">Native Hawaiian & other Pacific Islander</option>
            <option value="whiteNonHispanic">White Non Hispanic</option>
            <option value="other">Other</option>
            <option value="decline">Decline</option>
          </select>
        </div>
        <div className="mb-6">
          <label htmlFor="numberChildren" className="block font-semibold text-gray-800 text-sm mb-2 text-start">Number of children:</label>
          <input
            type="number"
            id="numberChildren"
            name="numberChildren"
            value={formData.numberChildren}
            onChange={handleInputChange}
            className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
          />
        </div>
        <div className="mb-6">
          <label htmlFor="whoLiveWithYou" className="block font-semibold text-gray-800 text-sm mb-2 text-start">Who lives at home with you:</label>
          <input
            type="text"
            id="whoLiveWithYou"
            name="whoLiveWithYou"
            value={formData.whoLiveWithYou}
            onChange={handleInputChange}
            className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
          />
        </div>
        <div className="mb-6">
          <label htmlFor="occupation" className="block font-semibold text-gray-800 text-sm mb-2 text-start">Occupation:</label>
          <input
            type="text"
            id="occupation"
            name="occupation"
            value={formData.occupation}
            onChange={handleInputChange}
            className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
          />
        </div>
        <div className="mb-6">
          <label htmlFor="education" className="block font-semibold text-gray-800 text-sm mb-2 text-start">Education completed</label>
          <div className="flex flex-col gap-2">
            {[
              { value: 'gradeSchool', label: 'Grade School' },
              { value: 'highSchool', label: 'High School' },
              { value: 'college', label: 'College' },
              { value: 'graduateSchool', label: 'Graduate School' },
            ].map((option) => (
              <label key={option.value} className="flex items-center cursor-pointer text-sm text-start">
                <input
                  type="radio"
                  name="education"
                  value={option.value}
                  checked={formData.education === option.value}
                  onChange={handleInputChange}
                  className="w-4 h-4 mr-2"
                />
                {option.label}
              </label>
            ))}
          </div>
        </div>
      </div>
      <div className="bg-white border border-gray-200 rounded-xl p-3 sm:p-4 md:p-5"
>
        <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Emotions</h4>
        <div className="mb-6">
          <p className="text-gray-800 text-sm mb-2 text-start">Over the past year, how often have you been Bothered by any of the following problems:</p>
          <p className="text-gray-800 text-sm mb-2 text-start">Please insert appropriate number of each Question, using the following:</p>
          <p className="text-gray-800 text-sm mb-2 text-start">0=Not at All</p>
          <p className="text-gray-800 text-sm mb-2 text-start">1=Several Days</p>
          <p className="text-gray-800 text-sm mb-2 text-start">2=More than half the days</p>
          <p className="text-gray-800 text-sm mb-2 text-start">3=Nearly every day</p>
        </div>
        <div className="mb-6">
          <label htmlFor="botheredByProblems" className="block font-semibold text-gray-800 text-sm mb-2 text-start">Little interest or pleasure in doing thing:</label>
          <input
            type="number"
            id="botheredByProblems"
            name="botheredByProblems"
            min={0}
            max={3}
            value={formData.botheredByProblems}
            onChange={handleInputChange}
            className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
          />
        </div>
        <div className="mb-6">
          <label htmlFor="littlePleasure" className="block font-semibold text-gray-800 text-sm mb-2 text-start">Feeling down, depressed or hopeless:</label>
          <input
            type="number"
            id="littlePleasure"
            name="littlePleasure"
            min={0}
            max={3}
            value={formData.littlePleasure}
            onChange={handleInputChange}
            className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
          />
        </div>
      </div>
    </div>
  </div>
</div>}
       {currentStep==6 && !isCompleted &&  <div className={`step-content ${currentStep === 6 ? 'block' : 'hidden'}`} id="step6">
  <div className="border border-gray-200 rounded-xl p-6 mb-6 bg-gray-50">
    <h3 className="text-lg font-semibold text-gray-800 mb-2 text-start">My Care Team</h3>
    <p className="text-gray-500 mb-2 text-sm leading-relaxed text-start">
      Please indicate if you have any other doctors/specialists helping you with your care.
    </p>
 <div className="border border-gray-200 rounded-lg overflow-hidden bg-white mb-5">
  {/* Header */}
  <div
    className="
      grid 
      grid-cols-1 
      sm:grid-cols-[2fr_2fr_1fr_100px] 
      border-b border-gray-100 bg-gray-50
    "
  >
    <div className="p-3 font-semibold text-sm text-gray-800 border-b sm:border-b-0 sm:border-r border-gray-200 text-start">
      SPECIALITY
    </div>
    <div className="p-3 font-semibold text-sm text-gray-800 border-b sm:border-b-0 sm:border-r border-gray-200 text-start">
      DOCTOR NAME
    </div>
    <div className="p-3 font-semibold text-sm text-gray-800 border-b sm:border-b-0 sm:border-r border-gray-200 text-start">
      PHONE
    </div>
    <div className="p-3 font-semibold text-sm text-gray-800 text-start text-center sm:text-start">
      ACTION
    </div>
  </div>

  {/* Rows */}
  <div id="careTeamRows">
    {formData.careTeam.map((member, index) => (
      <div
        key={index}
        className="
          grid 
          grid-cols-1 
          sm:grid-cols-[2fr_2fr_1fr_100px] 
          border-b border-gray-100
        "
      >
        {/* SPECIALTY */}
        <div className="p-3 border-b sm:border-b-0 sm:border-r border-gray-100">
          <input
            type="text"
            value={member.specialty}
            onChange={(e) =>
              updateTableRow(index, "specialty", e.target.value, "careTeam")
            }
            placeholder="Specialty"
            className="w-full border-none bg-transparent p-1 text-sm
                       focus:outline-none focus:bg-gray-50 focus:p-2 focus:rounded text-start"
          />
        </div>

        {/* DOCTOR NAME */}
        <div className="p-3 border-b sm:border-b-0 sm:border-r border-gray-100">
          <input
            type="text"
            value={member.doctorName}
            onChange={(e) =>
              updateTableRow(index, "doctorName", e.target.value, "careTeam")
            }
            placeholder="Doctor Name"
            className="w-full border-none bg-transparent p-1 text-sm
                       focus:outline-none focus:bg-gray-50 focus:p-2 focus:rounded text-start"
          />
        </div>

        {/* PHONE */}
        <div className="p-3 border-b sm:border-b-0 sm:border-r border-gray-100">
          <input
            type="text"
            value={member.phone}
            onChange={(e) => {
              const numericValue = e.target.value.replace(/\D/g, ""); 
              updateTableRow(index, "phone", numericValue, "careTeam");
            }}
            placeholder="Phone"
            className="w-full border-none bg-transparent p-1 text-sm
                       focus:outline-none focus:bg-gray-50 focus:p-2 focus:rounded text-start"
          />
        </div>

        {/* ACTION */}
        <div className="p-3 flex items-center justify-center">
          <button
            className="bg-red-500 text-white border-none w-6 h-6 rounded-full text-sm 
                       flex items-center justify-center hover:bg-red-600 hover:scale-110"
            onClick={() => removeTableRow(index, "careTeam")}
          >
            ×
          </button>
        </div>
      </div>
    ))}
  </div>
</div>

    <button
      type="button"
      className="bg-indigo-600 text-white border-none px-5 py-2.5 rounded-lg font-semibold text-sm hover:bg-indigo-700 hover:-translate-y-0.5 transition-all mb-5 block"
      onClick={addCareTeamRow}
    >
      + Add Row
    </button>
    <div className="mb-6">
      <label htmlFor="homeHealthCompany" className="block font-semibold text-gray-800 text-sm mb-2 text-start">Home Health Company</label>
      <input
        type="text"
        id="homeHealthCompany"
        name="homeHealthCompany"
        value={formData.homeHealthCompany}
        onChange={handleInputChange}
        placeholder="Enter home health company name"
        className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
      />
    </div>
  </div>
</div>}
 {currentStep === 7  && !isCompleted && (
  <div className={`step-content ${currentStep === 7 ? 'block' : 'hidden'}`} id="step7">
    <div className="border border-gray-200 rounded-xl p-6 mb-6 bg-gray-50">
      <h3 className="text-lg font-semibold text-gray-800 mb-2 text-start">Review of Systems</h3>
      <p className="text-gray-500 mb-2 text-sm leading-relaxed text-start">
        Please check any current problems you have on the list below.
      </p>

      {/* UPDATED GRID FOR MOBILE RESPONSIVE */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">

        {/* Breasts */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Breasts</h4>
          <div className="flex flex-col gap-2">
            <label className="flex items-center text-sm leading-snug text-start cursor-pointer">
              <input
                type="checkbox"
                name="BreastPain"
                checked={formData.reviewOfSystems.includes('BreastPain')}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    reviewOfSystems: e.target.checked
                      ? [...prev.reviewOfSystems, 'BreastPain']
                      : prev.reviewOfSystems.filter((s) => s !== 'BreastPain'),
                  }));
                }}
                className="mr-2"
              />
              BREAST PAIN/LUMP
            </label>
          </div>
        </div>

        {/* Constitutional */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Constitutional</h4>
          <div className="flex flex-col gap-2">
            {[
              { name: 'Fever', label: 'Fever/chills/sweats' },
              { name: 'UnexplainedWeightLoss', label: 'Unexplained weight loss' },
              { name: 'Fatigue', label: 'Fatigue/Weakness' },
            ].map((symptom) => (
              <label
                key={symptom.name}
                className="flex items-center text-sm leading-snug text-start cursor-pointer"
              >
                <input
                  type="checkbox"
                  name={symptom.name}
                  checked={formData.reviewOfSystems.includes(symptom.name)}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      reviewOfSystems: e.target.checked
                        ? [...prev.reviewOfSystems, symptom.name]
                        : prev.reviewOfSystems.filter((s) => s !== symptom.name),
                    }));
                  }}
                  className="mr-2"
                />
                {symptom.label}
              </label>
            ))}
          </div>
        </div>

        {/* Eyes */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Eyes</h4>
          <div className="flex flex-col gap-2">
            <label className="flex items-center text-sm leading-snug text-start cursor-pointer">
              <input
                type="checkbox"
                name="ChangeInVision"
                checked={formData.reviewOfSystems.includes('ChangeInVision')}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    reviewOfSystems: e.target.checked
                      ? [...prev.reviewOfSystems, 'ChangeInVision']
                      : prev.reviewOfSystems.filter((s) => s !== 'ChangeInVision'),
                  }));
                }}
                className="mr-2"
              />
              Change in vision
            </label>
          </div>
        </div>

        {/* Ears/Nose/Throat/Mouth */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Ears/Nose/Throat/Mouth</h4>
          <div className="flex flex-col gap-2">
            {[
              { name: 'DifficultHearing', label: 'Difficult hearing' },
              { name: 'RingingInEars', label: 'Ringing in ears' },
              { name: 'ProblemsWithTeeth', label: 'Problems with teeth/gums' },
              { name: 'HayFever', label: 'Hay fever/Allergies' },
            ].map((symptom) => (
              <label
                key={symptom.name}
                className="flex items-center text-sm leading-snug text-start cursor-pointer"
              >
                <input
                  type="checkbox"
                  name={symptom.name}
                  checked={formData.reviewOfSystems.includes(symptom.name)}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      reviewOfSystems: e.target.checked
                        ? [...prev.reviewOfSystems, symptom.name]
                        : prev.reviewOfSystems.filter((s) => s !== symptom.name),
                    }));
                  }}
                  className="mr-2"
                />
                {symptom.label}
              </label>
            ))}
          </div>
        </div>

        {/* Respiratory */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Respiratory</h4>
          <div className="flex flex-col gap-2">
            {[
              { name: 'CoughWheeze', label: 'Cough/Wheeze' },
              { name: 'DifficultBreathing', label: 'Difficulty breathing' },
            ].map((symptom) => (
              <label
                key={symptom.name}
                className="flex items-center text-sm leading-snug text-start cursor-pointer"
              >
                <input
                  type="checkbox"
                  name={symptom.name}
                  checked={formData.reviewOfSystems.includes(symptom.name)}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      reviewOfSystems: e.target.checked
                        ? [...prev.reviewOfSystems, symptom.name]
                        : prev.reviewOfSystems.filter((s) => s !== symptom.name),
                    }));
                  }}
                  className="mr-2"
                />
                {symptom.label}
              </label>
            ))}
          </div>
        </div>

        {/* Cardiovascular */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Cardiovascular</h4>
          <div className="flex flex-col gap-2">
            {[
              { name: 'ChestPain', label: 'Chest pain/Discomfort' },
              { name: 'LegPain', label: 'Leg pain with exercise' },
              { name: 'Palpitations', label: 'Palpitations' },
            ].map((symptom) => (
              <label
                key={symptom.name}
                className="flex items-center text-sm leading-snug text-start cursor-pointer"
              >
                <input
                  type="checkbox"
                  name={symptom.name}
                  checked={formData.reviewOfSystems.includes(symptom.name)}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      reviewOfSystems: e.target.checked
                        ? [...prev.reviewOfSystems, symptom.name]
                        : prev.reviewOfSystems.filter((s) => s !== symptom.name),
                    }));
                  }}
                  className="mr-2"
                />
                {symptom.label}
              </label>
            ))}
          </div>
        </div>

        {/* Gastrointestinal */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Gastrointestinal</h4>
          <div className="flex flex-col gap-2">
            {[
              { name: 'AbdominalPain', label: 'Abdominal Pain' },
              { name: 'Heartburn', label: 'Heartburn' },
              { name: 'BloodyBowel', label: 'Bloody/Black bowel movement' },
              { name: 'NauseaVomiting', label: 'Nausea/Vomiting/Diarrhea' },
              { name: 'Constipation', label: 'Constipation' },
              { name: 'ChangeInBowel', label: 'Change in bowel habits' },
            ].map((symptom) => (
              <label
                key={symptom.name}
                className="flex items-center text-sm leading-snug text-start cursor-pointer"
              >
                <input
                  type="checkbox"
                  name={symptom.name}
                  checked={formData.reviewOfSystems.includes(symptom.name)}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      reviewOfSystems: e.target.checked
                        ? [...prev.reviewOfSystems, symptom.name]
                        : prev.reviewOfSystems.filter((s) => s !== symptom.name),
                    }));
                  }}
                  className="mr-2"
                />
                {symptom.label}
              </label>
            ))}
          </div>
        </div>

        {/* Genitourinary */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Genitourinary</h4>
          <div className="flex flex-col gap-2">
            {[
              { name: 'NighttimeUrination', label: 'Nighttime urination' },
              { name: 'DifficultyUrination', label: 'Difficulty starting urination' },
              { name: 'LeakingUrine', label: 'Leaking urine' },
              { name: 'BloodInUrine', label: 'Blood in urine' },
              { name: 'DischargeFromPenis', label: 'Discharge from penis' },
              { name: 'SexualFunctionProblems', label: 'Sexual function problems' },
            ].map((symptom) => (
              <label
                key={symptom.name}
                className="flex items-center text-sm leading-snug text-start cursor-pointer"
              >
                <input
                  type="checkbox"
                  name={symptom.name}
                  checked={formData.reviewOfSystems.includes(symptom.name)}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      reviewOfSystems: e.target.checked
                        ? [...prev.reviewOfSystems, symptom.name]
                        : prev.reviewOfSystems.filter((s) => s !== symptom.name),
                    }));
                  }}
                  className="mr-2"
                />
                {symptom.label}
              </label>
            ))}
          </div>
        </div>

        {/* Musculoskeletal */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Musculoskeletal</h4>
          <div className="flex flex-col gap-2">
            <label className="flex items-center text-sm leading-snug text-start cursor-pointer">
              <input
                type="checkbox"
                name="MusculoskeletalPain"
                checked={formData.reviewOfSystems.includes('MusculoskeletalPain')}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    reviewOfSystems: e.target.checked
                      ? [...prev.reviewOfSystems, 'MusculoskeletalPain']
                      : prev.reviewOfSystems.filter((s) => s !== 'MusculoskeletalPain'),
                  }));
                }}
                className="mr-2"
              />
              Musculoskeletal pain or swelling
            </label>
          </div>
        </div>

        {/* Neurological */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Neurological</h4>
          <div className="flex flex-col gap-2">
            {[
              { name: 'Headaches', label: 'Headaches' },
              { name: 'Dizziness', label: 'Dizziness/Lightheadedness' },
              { name: 'Numbness', label: 'Numbness' },
              { name: 'MemoryLoss', label: 'Memory loss' },
              { name: 'LossOfCoordination', label: 'Loss of coordination' },
            ].map((symptom) => (
              <label
                key={symptom.name}
                className="flex items-center text-sm leading-snug text-start cursor-pointer"
              >
                <input
                  type="checkbox"
                  name={symptom.name}
                  checked={formData.reviewOfSystems.includes(symptom.name)}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      reviewOfSystems: e.target.checked
                        ? [...prev.reviewOfSystems, symptom.name]
                        : prev.reviewOfSystems.filter((s) => s !== symptom.name),
                    }));
                  }}
                  className="mr-2"
                />
                {symptom.label}
              </label>
            ))}
          </div>
        </div>

        {/* Psychiatric */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Psychiatric</h4>
          <div className="flex flex-col gap-2">
            {[
              { name: 'AnxietyStress', label: 'Anxiety/Stress' },
              { name: 'ProblemsWithSleep', label: 'Problems with sleep' },
              { name: 'Depression', label: 'Depression' },
            ].map((symptom) => (
              <label
                key={symptom.name}
                className="flex items-center text-sm leading-snug text-start cursor-pointer"
              >
                <input
                  type="checkbox"
                  name={symptom.name}
                  checked={formData.reviewOfSystems.includes(symptom.name)}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      reviewOfSystems: e.target.checked
                        ? [...prev.reviewOfSystems, symptom.name]
                        : prev.reviewOfSystems.filter((s) => s !== symptom.name),
                    }));
                  }}
                  className="mr-2"
                />
                {symptom.label}
              </label>
            ))}
          </div>
        </div>

        {/* Skin */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Skin</h4>
          <div className="flex flex-col gap-2">
            {[
              { name: 'RashMoles', label: 'Rash or mole changes' },
              { name: 'Itching', label: 'Itching' },
            ].map((symptom) => (
              <label
                key={symptom.name}
                className="flex items-center text-sm leading-snug text-start cursor-pointer"
              >
                <input
                  type="checkbox"
                  name={symptom.name}
                  checked={formData.reviewOfSystems.includes(symptom.name)}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      reviewOfSystems: e.target.checked
                        ? [...prev.reviewOfSystems, symptom.name]
                        : prev.reviewOfSystems.filter((s) => s !== symptom.name),
                    }));
                  }}
                  className="mr-2"
                />
                {symptom.label}
              </label>
            ))}
          </div>
        </div>

        {/* Blood/Lymphatic */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Blood/Lymphatic</h4>
          <div className="flex flex-col gap-2">
            {[
              { name: 'UnexpectedLumps', label: 'Unexpected lumps' },
              { name: 'BruisingBleeding', label: 'Easing bruising/bleeding' },
              { name: 'ExcessiveThirst', label: 'Excessive thirst or urination' },
            ].map((symptom) => (
              <label
                key={symptom.name}
                className="flex items-center text-sm leading-snug text-start cursor-pointer"
              >
                <input
                  type="checkbox"
                  name={symptom.name}
                  checked={formData.reviewOfSystems.includes(symptom.name)}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      reviewOfSystems: e.target.checked
                        ? [...prev.reviewOfSystems, symptom.name]
                        : prev.reviewOfSystems.filter((s) => s !== symptom.name),
                    }));
                  }}
                  className="mr-2"
                />
                {symptom.label}
              </label>
            ))}
          </div>
        </div>

      </div>

      {/* Other symptoms textarea */}
      <div className="mt-6">
        <label
          htmlFor="rosOther"
          className="block font-semibold text-gray-800 text-sm mb-2 text-start"
        >
          Other: (please specify)
        </label>
        <textarea
          id="rosOther"
          name="rosOther"
          rows={4}
          value={formData.rosOther}
          onChange={handleInputChange}
          placeholder="Describe any other symptoms"
          className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 focus:outline-none focus:border-indigo-600 focus:bg-white focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
        />
      </div>

    </div>
  </div>
)}


 {currentStep == 8 && !isCompleted && (
  <div className={`step-content ${currentStep === 8 ? "block" : "hidden"}`} id="step8">
    <div className="border border-gray-200 rounded-xl p-6 mb-6 bg-gray-50">
      <h3 className="text-lg font-semibold text-gray-800 mb-2 text-start">🩹 Immunizations & Vaccinations</h3>

      <p className="text-gray-500 mb-2 text-sm leading-relaxed text-start">
        Please list your most recent immunizations. Include your best estimate of the month and year of each immunization:
      </p>

      {/* BUTTONS WITH MOBILE STACKING */}
      <div className="flex flex-col sm:flex-row sm:gap-4 gap-3 mb-6">
        <button
          type="button"
          className="bg-indigo-600 text-white border-none px-5 py-2.5 rounded-lg font-semibold text-sm hover:bg-indigo-700 transition-all w-full sm:w-auto"
          onClick={selectCommonVaccines}
        >
          Select Common Adult Vaccines
        </button>

        <button
          type="button"
          className="bg-gray-200 text-gray-800 border-none px-5 py-2.5 rounded-lg font-semibold text-sm hover:bg-gray-300 transition-all w-full sm:w-auto"
          onClick={clearAllVaccines}
        >
          Clear All
        </button>
      </div>

      {/* MAIN GRID — WEB VIEW SAME, MOBILE ALREADY OK */}
      <div className="grid grid-cols-1 gap-6">

        {/* Hepatitis & Liver Protection */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">
            Hepatitis & Liver Protection
          </h4>

          {[
            { name: "hepatitisA", label: "HEPATITIS A", description: "Protects against Hepatitis A virus" },
            { name: "hepatitisB", label: "HEPATITIS B", description: "Protects against Hepatitis B virus" },
          ].map((vaccine) => (
            <div key={vaccine.name} className="mb-4">

              <label className="flex items-center cursor-pointer text-sm leading-snug text-start gap-3">
                <input
                  type="checkbox"
                  name={`vaccine-${vaccine.name}`}
                  checked={formData.immunizations[vaccine.name]?.received || false}
                  onChange={() => toggleVaccineDate(vaccine.name)}
                  className="cursor-pointer"
                />

                <div className="flex flex-col">
                  <span className="font-semibold text-gray-800">{vaccine.label}</span>
                  <span className="text-gray-500 text-xs">{vaccine.description}</span>
                </div>
              </label>

              <input
                type="month"
                id={`${vaccine.name}Date`}
                name={`${vaccine.name}Date`}
                disabled={!formData.immunizations[vaccine.name]?.received}
                value={formData.immunizations[vaccine.name]?.date || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    immunizations: {
                      ...prev.immunizations,
                      [vaccine.name]: {
                        ...prev.immunizations[vaccine.name],
                        date: e.target.value,
                      },
                    },
                  }))
                }
                className="w-full mt-2 p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 
                focus:outline-none focus:border-indigo-600 focus:bg-white 
                focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
              />
            </div>
          ))}
        </div>

        {/* Respiratory & Flu */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Respiratory & Flu</h4>

          {[
            { name: "pneumonia", label: "PNEUMOVAX (PNEUMONIA)", description: "Prevents pneumococcal disease" },
            { name: "shingles", label: "SHINGLES", description: "Prevents shingles/herpes zoster" },
          ].map((vaccine) => (
            <div key={vaccine.name} className="mb-4">

              <label className="flex items-center cursor-pointer text-sm leading-snug text-start gap-3">
                <input
                  type="checkbox"
                  name={`vaccine-${vaccine.name}`}
                  checked={formData.immunizations[vaccine.name]?.received || false}
                  onChange={() => toggleVaccineDate(vaccine.name)}
                  className="cursor-pointer"
                />

                <div className="flex flex-col">
                  <span className="font-semibold text-gray-800">{vaccine.label}</span>
                  <span className="text-gray-500 text-xs">{vaccine.description}</span>
                </div>
              </label>

              <input
                type="month"
                id={`${vaccine.name}Date`}
                name={`${vaccine.name}Date`}
                disabled={!formData.immunizations[vaccine.name]?.received}
                value={formData.immunizations[vaccine.name]?.date || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    immunizations: {
                      ...prev.immunizations,
                      [vaccine.name]: {
                        ...prev.immunizations[vaccine.name],
                        date: e.target.value,
                      },
                    },
                  }))
                }
                className="w-full mt-2 p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 
                focus:outline-none focus:border-indigo-600 focus:bg-white 
                focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
              />
            </div>
          ))}
        </div>

        {/* Childhood Diseases */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Common Childhood Diseases</h4>

          {[
            { name: "measles", label: "MEASLES", description: "Part of MMR vaccine" },
            { name: "mumps", label: "MUMPS", description: "Part of MMR vaccine" },
            { name: "rubella", label: "RUBELLA", description: "Part of MMR vaccine" },
            { name: "varicella", label: "VARICELLA (CHICKEN POX)", description: "Prevents chickenpox" },
          ].map((vaccine) => (
            <div key={vaccine.name} className="mb-4">

              <label className="flex items-center cursor-pointer text-sm leading-snug text-start gap-3">
                <input
                  type="checkbox"
                  name={`vaccine-${vaccine.name}`}
                  checked={formData.immunizations[vaccine.name]?.received || false}
                  onChange={() => toggleVaccineDate(vaccine.name)}
                  className="cursor-pointer"
                />

                <div className="flex flex-col">
                  <span className="font-semibold text-gray-800">{vaccine.label}</span>
                  <span className="text-gray-500 text-xs">{vaccine.description}</span>
                </div>
              </label>

              <input
                type="month"
                id={`${vaccine.name}Date`}
                name={`${vaccine.name}Date`}
                disabled={!formData.immunizations[vaccine.name]?.received}
                value={formData.immunizations[vaccine.name]?.date || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    immunizations: {
                      ...prev.immunizations,
                      [vaccine.name]: {
                        ...prev.immunizations[vaccine.name],
                        date: e.target.value,
                      },
                    },
                  }))
                }
                className="w-full mt-2 p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 
                focus:outline-none focus:border-indigo-600 focus:bg-white 
                focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
              />
            </div>
          ))}
        </div>

        {/* Other Important Vaccines */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Other Important Vaccines</h4>

          {[
            { name: "tetanus", label: "TETANUS (TD)", description: "Tetanus/Diphtheria booster" },
            { name: "hpv", label: "HPV", description: "Human Papillomavirus vaccine" },
            { name: "meningitis", label: "MENINGITIS", description: "Meningococcal vaccine" },
            { name: "otherVaccine", label: "OTHER VACCINE", description: "Specify below" },
          ].map((vaccine) => (
            <div key={vaccine.name} className="mb-4">

              <label className="flex items-center cursor-pointer text-sm leading-snug text-start gap-3">
                <input
                  type="checkbox"
                  name={`vaccine-${vaccine.name}`}
                  checked={formData.immunizations[vaccine.name]?.received || false}
                  onChange={() => toggleVaccineDate(vaccine.name)}
                  className="cursor-pointer"
                />

                <div className="flex flex-col">
                  <span className="font-semibold text-gray-800">{vaccine.label}</span>
                  <span className="text-gray-500 text-xs">{vaccine.description}</span>
                </div>
              </label>

              <input
                type="month"
                id={`${vaccine.name}Date`}
                name={`${vaccine.name}Date`}
                disabled={!formData.immunizations[vaccine.name]?.received}
                value={formData.immunizations[vaccine.name]?.date || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    immunizations: {
                      ...prev.immunizations,
                      [vaccine.name]: {
                        ...prev.immunizations[vaccine.name],
                        date: e.target.value,
                      },
                    },
                  }))
                }
                className="w-full mt-2 p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 
                focus:outline-none focus:border-indigo-600 focus:bg-white 
                focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
              />
            </div>
          ))}

          {/* OTHER VACCINE TEXT FIELD */}
          <div className="mt-3">
            <input
              type="text"
              id="otherVaccineDetails"
              name="otherVaccineDetails"
              value={formData.immunizations.otherVaccineDetails || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  immunizations: {
                    ...prev.immunizations,
                    otherVaccineDetails: e.target.value,
                  },
                }))
              }
              placeholder="Please specify other vaccine"
              className="w-full p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 
              focus:outline-none focus:border-indigo-600 focus:bg-white 
              focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
            />
          </div>
        </div>

        {/* Flu Vaccine */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Flu Vaccine</h4>

          <div className="mb-4">
            <label className="block font-semibold text-gray-800 text-sm mb-2 text-start">
              Can you tolerate the flu vaccine?
            </label>

            {/* Mobile Friendly Radio Group */}
            <div className="flex flex-wrap gap-4">
              <label className="flex items-center cursor-pointer text-start">
                <input
                  type="radio"
                  name="fluTolerance"
                  value="yes"
                  checked={formData.fluTolerance === "yes"}
                  onChange={handleInputChange}
                  className="mr-1.5"
                />
                Yes
              </label>

              <label className="flex items-center cursor-pointer text-start">
                <input
                  type="radio"
                  name="fluTolerance"
                  value="no"
                  checked={formData.fluTolerance === "no"}
                  onChange={handleInputChange}
                  className="mr-1.5"
                />
                No
              </label>
            </div>
          </div>

          <div className="mb-4">
            <label className="flex items-center cursor-pointer text-sm leading-snug text-start gap-3">
              <input
                type="checkbox"
                name="vaccine-flu"
                checked={formData.immunizations.flu?.received || false}
                onChange={() => toggleVaccineDate("flu")}
                className="cursor-pointer"
              />

              <div className="flex flex-col">
                <span className="font-semibold text-gray-800">FLU</span>
                <span className="text-gray-500 text-xs">Influenza vaccine</span>
              </div>
            </label>

            <input
              type="month"
              id="fluDate"
              name="fluDate"
              disabled={!formData.immunizations.flu?.received}
              value={formData.immunizations.flu?.date || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  immunizations: {
                    ...prev.immunizations,
                    flu: {
                      ...prev.immunizations.flu,
                      date: e.target.value,
                    },
                  },
                }))
              }
              className="w-full mt-2 p-3.5 border-2 border-gray-200 rounded-xl bg-gray-50 
              focus:outline-none focus:border-indigo-600 focus:bg-white 
              focus:shadow-[0_0_0_3px_rgba(79,70,229,0.1)] text-base text-start"
            />
          </div>
        </div>

        {/* Upload Vaccination Records */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">Upload Vaccination Records</h4>

          <div
            className="flex items-center gap-3 p-4 border-2 border-dashed border-gray-200 rounded-xl cursor-pointer hover:bg-gray-100 transition-all"
            onClick={() => document.getElementById("vaccineRecordsUpload").click()}
          >
            <svg fill="currentColor" viewBox="0 0 24 24" width="24" height="24" className="text-gray-500">
              <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
            </svg>

            <div className="flex flex-col">
              <span className="font-semibold text-gray-800">Upload Vaccination Card or Records</span>
              <span className="text-gray-500 text-xs">Take photos of your vaccination card or medical records</span>
            </div>
          </div>

          <input
            type="file"
            id="vaccineRecordsUpload"
          accept="image/*;capture=camera"
            multiple
            
            onChange={(e) => handleFileChange(e, "vaccineRecords")}
            className="hidden"
          />

          {/* IMAGE PREVIEW WITH MOBILE RESPONSIVE GRID */}
          <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {formData.vaccineRecords.map((img, index) => (
              <div key={index} className="relative">

                <img
                  src={URL.createObjectURL(img)}
                  alt="Vaccine Record"
                  className="w-full h-32 object-cover rounded-lg"
                />

                <button
                  className="absolute top-2 right-2 bg-red-500 text-white border-none w-6 h-6 rounded-full text-sm flex items-center justify-center hover:bg-red-600"
                  onClick={() => removeImage(index, "vaccineRecords")}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  </div>
)}

           {currentStep==9 && !isCompleted && <div className={`step-content ${currentStep === 9 ? 'block' : 'hidden'}`} id="step9">
  <div className="border border-gray-200 rounded-xl p-6 mb-6 bg-gray-50">
    <h3 className="text-lg font-semibold text-gray-800 mb-2 text-start">Review & Submit</h3>
    <p className="text-gray-500 mb-2 text-sm leading-relaxed text-start">
      Please review all information before submitting your registration.
    </p>
    <div id="reviewContent" className="mb-4">
    
    </div>
    <div className="medical-section">
      <h3 className="text-lg font-semibold text-gray-800 mb-2 text-start">Privacy Policy & Important Disclosures</h3>
      <div className="bg-gray-50 border border-gray-200 rounded-xl p-6 mb-6">
        <h4 className="text-base font-semibold text-gray-800 mb-4 text-start">HIPAA Privacy Notice</h4>
        <p className="text-gray-600 text-sm leading-relaxed mb-3 text-start">
          Center for Hypertension is committed to protecting your health information. We are required by law to maintain the privacy and security of your protected health information (PHI). This notice describes how medical information about you may be used and disclosed and how you can access this information.
        </p>
        <p className="text-gray-600 text-sm leading-relaxed mb-3 text-start">
          <strong>Uses and Disclosures:</strong> We may use or disclose your PHI for treatment, payment, and healthcare operations. We may also disclose your information as required by law, for public health activities, health oversight activities, judicial proceedings, law enforcement purposes, and other purposes as permitted or required by law.
        </p>
        <p className="text-gray-600 text-sm leading-relaxed text-start">
          <strong>Your Rights:</strong> You have the right to access, amend, restrict, and request an accounting of disclosures of your PHI. You may request communications through alternative means or locations. A complete Notice of Privacy Practices will be provided to you and is available on our website.
        </p>
      </div>
      <div className="bg-amber-50 border border-amber-400 rounded-xl p-6 mb-6">
        <h4 className="text-base font-semibold text-amber-900 mb-4 text-start">AI Scribe Technology Disclosure</h4>
        <p className="text-amber-900 text-sm leading-relaxed mb-3 text-start">
          <strong>Important Notice:</strong> Center for Hypertension may use Artificial Intelligence (AI) scribes and automated documentation systems to assist healthcare providers in documenting patient encounters and medical records.
        </p>
        <p className="text-amber-900 text-sm leading-relaxed mb-3 text-start">
          These AI systems may record, transcribe, and analyze conversations between patients and healthcare providers to generate clinical documentation. All AI-generated content is reviewed and verified by licensed healthcare professionals before being included in your medical record.
        </p>
        <p className="text-amber-900 text-sm leading-relaxed text-start">
          The AI systems are designed with privacy and security safeguards and comply with HIPAA regulations. Your conversations and medical information remain protected and confidential.
        </p>
      </div>
      <div className="bg-emerald-50 border border-emerald-400 rounded-xl p-6 mb-6">
        <h4 className="text-base font-semibold text-emerald-900 mb-4 text-start">Electronic Communication & Data Security</h4>
        <p className="text-emerald-900 text-sm leading-relaxed mb-3 text-start">
          This form and your information are transmitted using secure, encrypted connections. We use industry-standard security measures to protect your personal and medical information during transmission and storage.
        </p>
        <p className="text-emerald-900 text-sm leading-relaxed text-start">
          By submitting this form electronically, you acknowledge that you understand and accept the minimal risks associated with electronic transmission of health information over the internet.
        </p>
      </div>
      <div className="bg-white border-2 border-indigo-600 rounded-xl p-6">
        <h4 className="text-base font-semibold text-indigo-600 mb-5 text-start">Required Consents</h4>
        {[
          {
            id: 'privacyConsent',
            label: 'I acknowledge that I have read and understand the HIPAA Privacy Notice and agree to the use and disclosure of my health information as described.',
          },
          {
            id: 'aiScribeConsent',
            label: 'I understand and consent to the use of AI scribes and automated documentation systems during my healthcare encounters at Center for Hypertension.',
          },
          {
            id: 'electronicConsent',
            label: 'I consent to electronic communication and understand the risks associated with electronic transmission of health information.',
          },
          {
            id: 'accuracyConsent',
            label: 'I certify that all information provided in this registration form is accurate and complete to the best of my knowledge.',
          },
          {
            id: 'treatmentConsent',
            label: 'I consent to treatment and authorize Center for Hypertension to provide medical care and services.',
          },
        ].map((consent) => (
          <div key={consent.id} className="mb-4">
         <label className="flex items-center cursor-pointer text-sm leading-snug text-start space-x-2">
  <input
    type="checkbox"
    id={consent.id}
    name={consent.id}
    checked={formData[consent.id] || false}
    onChange={(e) =>
      setFormData((prev) => ({
        ...prev,
        [consent.id]: e.target.checked,
      }))
    }
    required
    className="w-5 h-5 cursor-pointer"
  />
  <span>{consent.label}</span>
</label>

          </div>
        ))}
      </div>
      <div className="mt-5 p-4 bg-gray-100 rounded-lg text-center">
        <p className="text-gray-600 text-xs m-0">
          By clicking "Submit Registration" below, you acknowledge that you have read, understood, and agree to all terms, policies, and consents outlined above.
        </p>
      </div>
    </div>
  </div>
</div>}
 {!isCompleted && ( 
    <div className="
  flex flex-col gap-4 mt-6 
  md:flex-row md:justify-between md:items-center
">
  {/* Previous Button */}
  <button
    type="button"
    id="prevBtn"
    onClick={previousStep}
className={`w-full md:w-auto px-8 py-2 sm:py-3 md:py-3 text-base font-semibold rounded-xl border-2 transition-all duration-300 ${
  currentStep === 1
    ? "hidden md:block opacity-0 pointer-events-none"
    : "bg-transparent text-gray-500 border-gray-300 hover:bg-gray-50 hover:border-gray-400"
}`}

  >
    ← Previous
  </button>

  {/* Clear Step Button */}
  <button
    type="button"
    className="w-full md:w-auto px-8 py-2 sm:py-3 md:py-3 text-base font-semibold rounded-xl border-2 bg-transparent text-gray-500 border-gray-300 hover:bg-gray-50 hover:border-gray-400 transition-all duration-300"
    onClick={clearCurrentStep}
  >
    Clear Step
  </button>

  {/* Next / Submit Button */}
  <button
    type="button"
    id="nextBtn"
    onClick={validateFields}
    className="w-full md:w-auto px-8 py-2 sm:py-3 md:py-3 text-base font-semibold rounded-xl border-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white hover:-translate-y-0.5 hover:shadow-[0_10px_25px_rgba(79,70,229,0.3)] transition-all duration-300"
  >
    {currentStep === 9 ? "Submit Registration" : "Continue →"}
  </button>
</div>
 )}
          </div>
        </div>
        )}
      </div>
        <Backdrop
  sx={{
    color: '#fff',
    zIndex: (theme) => theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity (default is 0.5)
  }}
  open={isLoading}
>
  <CircularProgress color="inherit" />
</Backdrop>
<DisclaimerModal
  open={showDisclaimer}
  onAgree={() => setShowDisclaimer(false)}
  onDisagree={() => {
    setShowDisclaimer(false);
    setShowConfirmModal(true);
  }}
/>
{isOtpOpen && (
<SaveProgressModal
    email={email}
    phone={phone}
    isOpen={isOtpOpen}
    generatedOtp={otp}
    onVerify={handleVerify}
    onSkip={handleSkip}
  />
)}
{isCompleted && (
<HealthQuestionnaires practiceId={practiseid} rowId={rowId} healthCompleted={healthCompleted} />
)}
<ConfirmAgreementModal
  open={showConfirmModal}
  onFinalAgree={() => setShowConfirmModal(false)}
/>

          <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handlealert} />
    </SideNavLayout>
     )}
    </>
  );
};

export default PatientOnboarding;